<template>
  <v-container fluid>
    <v-row>
      <!-- Dashboard para Vendedores — também acessível a quem tem a permissão master de filtro de
           vendedor (dashboard_vendedor_filtro_master), pra poder escolher um vendedor abaixo e ver a
           dashboard dele -->
      <v-col v-if="usuario.idgrupo === 7 || permissao('dashboard_vendedor_filtro_master')" class="pa-0">

        <!-- Filtro de Vendedor — visão gerencial: só aparece pra quem tem a permissão master
             (dashboard_vendedor_filtro_master). Escolher um vendedor aqui manda idvendedor pro backend nas
             3 chamadas de dashboard (Métricas, Campanha de Vendas e Campanha E-book), que só aceita o
             parâmetro se quem chamou tiver essa mesma permissão (ver ResolverIdVendedorFiltroMaster no
             backend) -->
        <v-col v-if="permissao('dashboard_vendedor_filtro_master')" cols="12" class="pa-0">
          <v-card flat class="mb-4 pa-4 campanha-vm-card">
            <div class="d-flex align-center mb-3">
              <div class="campanha-vm-icon-wrapper campanha-vm-icon-wrapper--active mr-3">
                <v-icon color="white" size="20">mdi-account-search-outline</v-icon>
              </div>
              <div class="flex-grow-1">
                <div style="font-size: 14px; font-weight: 700; color: #023449;">Visão gerencial</div>
                <div class="text--secondary" style="font-size: 12px;">Veja a dashboard como se fosse outro vendedor</div>
              </div>
            </div>
            <v-autocomplete v-model="idvendedor" :search-input.sync="search" :items="vendedores"
                            :loading="carregandoVendedores" item-text="nome" item-value="idcliente"
                            label="Buscar vendedor pelo nome" outlined dense
                            class="campanha-vm-filtro-vendedor-input"
                            prepend-inner-icon="mdi-magnify" hide-details clearable no-filter color="primary">
            </v-autocomplete>
          </v-card>
        </v-col>

        <!-- Com o filtro master ativo e nenhum vendedor escolhido ainda, não faz sentido carregar/mostrar
             nada (seria a dashboard de quem clicou no filtro, não de "um vendedor" — confuso). Esconde tudo
             abaixo e pede pra selecionar alguém primeiro -->
        <template v-if="!precisaSelecionarVendedor">

        <!-- Balão de boas-vindas -->
        <v-card class="mb-4" elevation="2" style="border-left: 5px solid #022f42; border-radius: 12px;">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <v-avatar size="44" class="mr-4" style="background: linear-gradient(135deg, #00586d, #022f42);">
                <v-icon dark size="22">mdi-account-star</v-icon>
              </v-avatar>
              <div class="flex-grow-1">
                <h3 class="primary--text font-weight-bold mb-1">Olá, {{ getPrimeiroNome(usuario.nome) }}! 🎯</h3>
                <!-- com o filtro master ativo, deixa claro de quem são os dados abaixo (senão "Olá, Vitor"
                     some da tela, mas os números continuam sendo de outro vendedor, o que confunde) -->
                <p v-if="nomeVendedorSelecionado" class="grey--text text--darken-1 mb-0">
                  Visualizando a dashboard de <strong>{{ nomeVendedorSelecionado }}</strong>.
                </p>
                <p v-else-if="isMesEAnoAtual(dtdia)" class="grey--text text--darken-1 mb-0">Bem-vindo à sua nova Dashboard.
                  Acompanhe aqui seu desempenho e sua projeção de bonificação.</p>
                <p v-else class="grey--text text--darken-1 mb-0">Bem-vindo à sua nova Dashboard. Acompanhe aqui seu
                  desempenho.</p>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- NAVEGAÇÃO ENTRE SEÇÕES — a barra de navegação global do topo (ToolbarContainer, em
             InicioContainer.vue) só mostra "HOME" pra quem não tem nenhuma outra permissão de dashboard
             gerencial, que é o caso do vendedor comum, então ela fica inútil pra ele (ver
             InicioContainer.vue: o v-col do toolbar só aparece quando menu.length > 1). Essas tabs locais
             substituem isso com uma navegação de verdade entre as seções que o vendedor tem nesta página —
             mostra só o conteúdo da aba selecionada, sem misturar tudo numa rolagem só. Envolvidas num card
             branco (mesmo campanha-vm-card dos outros blocos), em vez de ficarem soltas no fundo cinza da
             página, pra combinar com o resto da dashboard -->
        <v-card flat class="mb-4 pa-2 campanha-vm-card">
          <v-tabs v-model="abaVendedorAtiva" color="#023449" class="campanha-vm-tabs-vendedor" background-color="transparent" slider-size="0">
            <v-tab v-if="podeVerCampanhaVendaMargemVendedor" href="#campanha-vendas">
              <v-icon left size="18">mdi-trophy-award</v-icon>
              Campanha de Vendas
            </v-tab>
            <v-tab v-if="podeVerCampanhaEbookVendedor" href="#campanha-ebook">
              <v-icon left size="18">mdi-book-open-page-variant</v-icon>
              Campanha E-book
            </v-tab>
            <v-tab href="#metricas-vendas">
              <v-icon left size="18">mdi-chart-line</v-icon>
              Métricas de Vendas
            </v-tab>
          </v-tabs>
        </v-card>

        <!-- Card de Bonificação -->
        <v-card v-if="isMesEAnoAtual(dtdia)" class="mb-6" elevation="3"
                style="background: linear-gradient(135deg, #00586d 0%, #022f42 100%); border-radius: 12px;">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <v-avatar size="44" color="white" class="mr-3">
                <v-icon color="primary" size="22">mdi-gift</v-icon>
              </v-avatar>
              <div>
                <h3 class="white--text font-weight-bold mb-1">Bonificação Junho de 2025</h3>
                <p class="white--text mb-0">{{ avaliacaoAtual.mensagem }}</p>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Card Campanha de Vendas 2ª Edição — estilo alinhado ao PainelFiltros.vue (cartão branco com
             borda/sombra sutil, ícone em wrapper com gradiente navy, seções internas em "caixa" com
             gradiente claro + borda, em vez de blocos cinza chapado) -->
        <v-card v-if="abaVendedorAtiva === 'campanha-vendas' && podeVerCampanhaVendaMargemVendedor" flat class="mb-6 pa-4 campanha-vm-card">
          <template v-if="carregandoCampanhaVendaMargemVendedor">
            <div class="d-flex align-center mb-4">
              <v-skeleton-loader type="avatar" class="mr-3"></v-skeleton-loader>
              <div class="flex-grow-1">
                <v-skeleton-loader type="text" max-width="220" class="mb-1"></v-skeleton-loader>
                <v-skeleton-loader type="text" max-width="160"></v-skeleton-loader>
              </div>
            </div>
            <v-skeleton-loader type="image" height="40" class="mb-4" style="border-radius: 8px;"></v-skeleton-loader>
            <v-skeleton-loader type="image" height="72" class="mb-4" style="border-radius: 8px;"></v-skeleton-loader>
            <v-skeleton-loader type="text" class="mb-2" v-for="n in 4" :key="n"></v-skeleton-loader>
          </template>

          <template v-else>
            <div class="mb-4 d-flex align-center">
              <div class="campanha-vm-icon-wrapper campanha-vm-icon-wrapper--active mr-3">
                <v-icon color="white" size="20">mdi-trophy-award</v-icon>
              </div>
              <div class="flex-grow-1">
                <div class="campanha-vm-titulo">Campanha de Vendas 2ª Edição</div>
                <div class="text--secondary" style="font-size: 13px;">2º Semestre 2026</div>
              </div>
            </div>

            <template v-if="!campanhaVendaMargemVendedorAcumulado">
              <div class="d-flex align-center pa-4 mb-4 campanha-vm-box">
                <v-avatar size="56" color="white" class="mr-4" style="border: 1px solid #e2e8f0;">
                  <v-icon size="26" color="#64748b">mdi-trophy-outline</v-icon>
                </v-avatar>
                <div>
                  <div style="font-size: 16px; font-weight: 500;">Você ainda não pontuou na campanha</div>
                  <div class="text--secondary" style="font-size: 13px;">Toda venda conta pontos. Comece a pontuar esse mês.</div>
                </div>
              </div>
            </template>

            <template v-else>
              <!-- HERO — sempre o acumulado da campanha inteira, que é o que de fato vale pro sorteio.
                   Incorpora o antigo card "campanhaVendaMargemTagPremio" (classificação + o que ela
                   significa), com a faixa colorida da classificação. Sem o "% de atingimento" aqui — esse
                   número já aparece na barra de progresso do card logo abaixo, não precisa repetir -->
              <div
                  class="d-flex align-center pa-4 mb-4 campanha-vm-tag-premio"
                  :style="{
                    borderLeftColor: `rgb(${classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao).join(',')})`,
                    background: `linear-gradient(135deg, rgba(${classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao).join(',')}, 0.08) 0%, rgba(${classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao).join(',')}, 0.02) 100%)`,
                  }"
              >
                <div
                    class="d-flex align-center justify-center mr-5"
                    :style="{ width: '56px', height: '56px', borderRadius: '50%', background: medalCampanhaVendaMargem.bg, flexShrink: 0 }"
                >
                  <v-icon :color="medalCampanhaVendaMargem.text" size="26">{{ medalCampanhaVendaMargem.icon }}</v-icon>
                </div>
                <div>
                  <!-- classificação sem repetir o mesmo nome duas vezes: NÃO ATINGIU tem uma frase própria
                       (sem chip, já que "sem prêmio garantido" não é uma classificação pra exibir em chip);
                       as demais mostram o chip embutido logo após o rótulo, em vez de um chip solto em cima
                       e o mesmo nome de novo escrito ao lado -->
                  <div class="d-flex align-center mb-1" style="gap: 6px;">
                    <span
                        v-if="campanhaVendaMargemTagPremio"
                        class="font-weight-bold"
                        :style="{ fontSize: '12px', color: `rgb(${classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao).join(',')})` }"
                    >{{ campanhaVendaMargemTagPremio.tag }}</span>
                    <template v-else>
                      <span
                          class="font-weight-bold"
                          :style="{ fontSize: '12px', color: `rgb(${classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao).join(',')})` }"
                      >Classificação atual:</span>
                      <v-chip x-small :color="classificacaoCorAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao)" dark class="font-weight-bold">
                        {{ campanhaVendaMargemVendedorAcumulado.classificacao }}
                      </v-chip>
                    </template>
                  </div>
                  <!-- dois números em vez de um total só: o mês corrente ainda não fechou, então os cupons
                       dele ainda podem mudar até lá — misturar isso com os cupons já garantidos (meses
                       fechados) passaria a falsa impressão de que o total já está travado -->
                  <div class="d-flex align-center flex-wrap" style="gap: 20px;">
                    <div>
                      <div style="font-size: 24px; font-weight: 700; color: #023449;">{{ campanhaVendaMargemCuponsGarantidos }} cupons</div>
                      <div class="text--secondary" style="font-size: 11px;">Garantidos (meses fechados)</div>
                    </div>
                    <div v-if="campanhaVendaMargemCuponsMesAtual > 0">
                      <div style="font-size: 24px; font-weight: 700; color: #0369a1;">+{{ campanhaVendaMargemCuponsMesAtual }} cupons</div>
                      <div class="text--secondary" style="font-size: 11px;">Neste mês (ainda pode mudar)</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ALERTA: classificação OURO mas admitido depois do corte da campanha (01/10/2026) — sem
                   concorrer ao sorteio do OURO por regra, mesmo com o desempenho pra isso. Bem sinalizado de
                   propósito (prominent + borda grossa), logo abaixo do HERO, pra não passar batido -->
              <v-alert
                  v-if="campanhaVendaMargemAlertaOuroAdmitidoTardio"
                  type="warning"
                  prominent
                  border="left"
                  colored-border
                  elevation="1"
                  icon="mdi-alert-circle-outline"
                  class="mb-4"
                  style="font-size: 13px;"
              >
                <div class="font-weight-bold mb-1">Sua classificação acumulada é OURO, mas você não concorre ao sorteio do prêmio OURO</div>
                <div>
                  Como você entrou na campanha depois de 01/10/2026, essa é uma regra especial pra quem foi
                  admitido nessa fase. Você continua concorrendo aos demais sorteios (PRATA e BRONZE), desde
                  que mantenha as vendas mensais acima de R$ 130.000,00 (ou da sua meta do mês, se ela for
                  maior que isso).
                </div>
              </v-alert>

              <!-- MENSAGEM MOTIVACIONAL + PROGRESSO — acumulado e mês corrente em cards separados (antes
                   dividiam a mesma caixa com um v-divider no meio) -->
              <div class="pa-3 mb-4 campanha-vm-box">
                <div class="d-flex mb-3" style="gap: 10px;">
                  <v-icon color="#023449" size="18">mdi-lightbulb-on-outline</v-icon>
                  <span class="text--secondary" style="font-size: 13px;">{{ campanhaVendaMargemMensagem }}</span>
                </div>
                <div class="campanha-vm-faixa-legenda">% da meta acumulada da campanha atingida</div>
                <campanha-venda-margem-faixas
                  :percentual="campanhaVendaMargemVendedorAcumulado.peratingimento"
                  :percentual-label="formatarPercentual(campanhaVendaMargemVendedorAcumulado.peratingimento)"
                  :classificacao="campanhaVendaMargemVendedorAcumulado.classificacao"
                  :cor-rgb="classificacaoCorRGBAcumulado(campanhaVendaMargemVendedorAcumulado.classificacao)"
                  :escala-max="campanhaVendaMargemFaixasEscalaMax"
                />
              </div>

              <div v-if="campanhaVendaMargemMesAtualResumo" class="pa-3 mb-4 campanha-vm-box">
                <div v-if="campanhaVendaMargemMensagemProjecao" class="d-flex mb-3" style="gap: 10px;">
                  <v-icon color="#023449" size="18">mdi-trending-up</v-icon>
                  <span class="text--secondary" style="font-size: 13px;">{{ campanhaVendaMargemMensagemProjecao }}</span>
                </div>
                <div class="campanha-vm-faixa-legenda">% da meta de {{ campanhaVendaMargemMesAtualResumo.mes_formatado.split('/')[0] }} atingida</div>
                <campanha-venda-margem-faixas
                  :percentual="campanhaVendaMargemMesAtualResumo.peratingimento"
                  :percentual-label="formatarPercentual(campanhaVendaMargemMesAtualResumo.peratingimento)"
                  :classificacao="campanhaVendaMargemMesAtualResumo.classificacao"
                  :cor-rgb="classificacaoCorRGBAcumulado(campanhaVendaMargemMesAtualResumo.classificacao)"
                  :escala-max="campanhaVendaMargemFaixasEscalaMax"
                />
              </div>

              <!-- PONTOS POR REGRA — aqui sim entra o seletor de período, pra explorar mês a mês. Título e
                   legenda fora da caixa, mesmo padrão de "Prêmios da campanha" e "Dicas para ganhar mais
                   pontos" logo abaixo (título solto na página, conteúdo em caixa à parte). O botão "Como
                   funciona a campanha" morava lá em cima, no cabeçalho do card, como um ícone discreto
                   fácil de passar batido — trazido pra cá, do lado do título mais relevante pra quem quer
                   entender as regras, e com texto (não só ícone) pra ficar mais fácil de identificar -->
              <div class="d-flex align-center justify-space-between mb-2">
                <div class="campanha-vm-box-titulo">Pontos por regra</div>
                <v-btn text small color="#0369a1" class="campanha-vm-btn-como-funciona" @click="dialogRegrasCampanhaVendaMargem = true">
                  <v-icon size="16" class="mr-1">mdi-information-outline</v-icon>
                  Como funciona
                </v-btn>
              </div>
              <div class="pa-3 mb-4 campanha-vm-box">
                <!-- todos os períodos numa lista, cada um expansível -->
                <v-expansion-panels flat accordion class="campanha-vm-historico">
                  <v-expansion-panel
                      v-for="periodo in campanhaVendaMargemHistorico"
                      :key="periodo.chave"
                      :class="{ 'campanha-vm-historico-total': periodo.chave === 'acumulado' }"
                  >
                    <v-expansion-panel-header class="campanha-vm-historico-header">
                      <div class="d-flex align-center justify-space-between campanha-vm-historico-linha" style="gap: 8px; padding-right: 8px;">
                        <div class="d-flex align-center" style="gap: 8px;">
                          <v-icon size="16" color="#023449">{{ periodo.icone }}</v-icon>
                          <span class="font-weight-bold" style="font-size: 13px; color: #023449;">{{ periodo.label }}</span>
                        </div>
                        <!-- chip e cupons em colunas de largura fixa (mesma largura total nas 3 variantes,
                             senão o grupo inteiro desalinha, já que fica encostado na borda direita via
                             justify-space-between) — alinha as linhas mesmo o texto do chip variando bastante
                             ("OURO" x "Em andamento" x "NÃO ATINGIU") -->
                        <!-- Total Geral: sem "+" (não é ganho novo, é o resultado final acumulado) -->
                        <div v-if="periodo.chave === 'acumulado' && periodo.dados" class="d-flex align-center campanha-vm-historico-variante">
                          <div class="d-flex align-center justify-end campanha-vm-historico-chip-col">
                            <!-- ícone (troféu ou relógio) + classificação dentro do próprio chip: reforça que
                                 essa é a classificação que vale pro sorteio de verdade (diferente dos meses
                                 individuais, que só mostram a classificação daquele mês isolado) -->
                            <v-chip x-small :color="classificacaoCor(periodo.dados.classificacao)" dark class="font-weight-bold">
                              <v-icon size="14" left>{{ classificacaoIconeAcumulado(periodo.dados.classificacao) }}</v-icon>
                              {{ periodo.dados.classificacao }}
                            </v-chip>
                          </div>
                          <div class="d-flex align-center campanha-vm-historico-cupons-col">
                            <span class="font-weight-bold" style="font-size: 14px; color: #023449;">{{ periodo.dados.total_cupons }} cupons</span>
                          </div>
                        </div>
                        <!-- meses: "+" verde só quando de fato ganhou algo (qtd > 0) — com 0 cupons não tem
                             o que somar, então o "+" não faz sentido e a cor volta a ser neutra -->
                        <div v-else-if="periodo.dados && periodo.emAndamento" class="d-flex align-center campanha-vm-historico-variante">
                          <!-- em vez do chip sólido "Em andamento", um spinner mesmo — comunica melhor que o
                               mês ainda está "carregando"/em apuração, os números ainda não fecharam -->
                          <div class="d-flex align-center justify-end campanha-vm-historico-chip-col">
                            <v-progress-circular indeterminate size="14" width="2" color="#0369a1" class="mr-1 campanha-vm-spinner-mes-atual"></v-progress-circular>
                            <span class="font-weight-bold" style="font-size: 11px; color: #0369a1;">Em andamento</span>
                          </div>
                          <div class="d-flex align-center campanha-vm-historico-cupons-col">
                            <v-icon v-if="periodo.dados.total_cupons > 0" size="14" color="#10b981" class="mr-1">mdi-plus</v-icon>
                            <span class="font-weight-bold" :style="{ fontSize: '13px', color: periodo.dados.total_cupons > 0 ? '#10b981' : '#64748b' }">{{ periodo.dados.total_cupons }} cupons até agora</span>
                          </div>
                        </div>
                        <div v-else-if="periodo.dados" class="d-flex align-center campanha-vm-historico-variante">
                          <div class="d-flex align-center justify-end campanha-vm-historico-chip-col">
                            <v-chip x-small :color="classificacaoCor(periodo.dados.classificacao)" dark class="font-weight-bold">{{ periodo.dados.classificacao }}</v-chip>
                          </div>
                          <div class="d-flex align-center campanha-vm-historico-cupons-col">
                            <v-icon v-if="periodo.dados.total_cupons > 0" size="14" color="#10b981" class="mr-1">mdi-plus</v-icon>
                            <span class="font-weight-bold" :style="{ fontSize: '13px', color: periodo.dados.total_cupons > 0 ? '#10b981' : '#64748b' }">{{ periodo.dados.total_cupons }} cupons</span>
                          </div>
                        </div>
                        <span v-else class="text--secondary" style="font-size: 12px;">Sem dados</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-if="!periodo.dados" class="text--secondary text-center py-3" style="font-size: 13px;">
                        Sem participação nesse período.
                      </div>
                      <!-- Total Geral com todos os blocos zerados (filtrados acima) — raro, mas evita a
                           grade aparecer vazia sem nenhuma explicação -->
                      <div v-else-if="!periodo.pontos.length" class="text--secondary text-center py-3" style="font-size: 13px;">
                        Nenhum cupom acumulado ainda.
                      </div>
                      <div v-else class="d-flex flex-wrap campanha-vm-regra-grid pt-2">
                        <div
                            v-for="item in periodo.pontos"
                            :key="item.label"
                            class="campanha-vm-regra-card-wrap"
                            :class="{ 'campanha-vm-regra-card-wrap--poucos': periodo.pontos.length <= 2 }"
                        >
                          <div
                              class="pa-3 campanha-vm-regra-card"
                              :class="{
                                'campanha-vm-regra-card--positivo': item.qtd > 0,
                                'campanha-vm-regra-card--proximo': item.qtd === 0 && item.falta,
                              }"
                          >
                            <div class="d-flex align-center" style="gap: 8px;">
                              <v-icon :color="item.qtd > 0 ? '#023449' : '#94a3b8'" size="18">{{ item.icone }}</v-icon>
                              <div class="d-flex align-center">
                                <v-icon v-if="item.qtd > 0 && periodo.chave !== 'acumulado'" size="16" color="#10b981" class="mr-1">mdi-plus</v-icon>
                                <span :style="{ fontSize: '22px', fontWeight: 700, color: item.qtd > 0 && periodo.chave !== 'acumulado' ? '#10b981' : '#023449' }">{{ item.qtd }}</span>
                              </div>
                            </div>
                            <div class="d-flex align-center mt-1" style="gap: 3px;">
                              <span class="font-weight-bold" style="font-size: 12px; color: #023449;">{{ item.label }}</span>
                              <!-- mesmo texto do dialog "Como funciona a campanha", sob demanda, sem
                                   precisar sair do card pra entender a regra -->
                              <v-tooltip v-if="item.explicacao" bottom max-width="260">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" size="12" color="#94a3b8">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ item.explicacao }}</span>
                              </v-tooltip>
                            </div>
                            <div v-if="item.falta" style="font-size: 11px; line-height: 1.3; color: #b45309;">{{ item.falta }}</div>
                            <div v-else class="text--secondary" style="font-size: 11px; line-height: 1.3;">{{ item.sublabel }}</div>
                            <div v-if="item.aviso" class="d-flex align-start mt-1" style="gap: 4px;">
                              <v-icon size="12" color="#94a3b8" style="margin-top: 1px;">mdi-alert-outline</v-icon>
                              <span style="font-size: 10px; line-height: 1.3; color: #64748b;">{{ item.aviso }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </template>

            <!-- PRÊMIOS POR CLASSIFICAÇÃO -->
            <div class="campanha-vm-box-titulo mb-2">Prêmios da campanha</div>

            <!-- v-row do Vuetify tem margin:-12px embutido (compensa o gutter interno dos v-col) — sem a
                 correção no CSS (campanha-vm-premios-lista), esse -12px "comia" boa parte do mt-4 do título
                 "Dicas para ganhar mais pontos" logo abaixo, deixando os dois praticamente colados -->
            <v-row dense class="campanha-vm-premios-lista">
              <v-col v-for="classificacao in ordemClassificacaoPremiosCampanhaVendaMargem" :key="classificacao" cols="12" sm="4" class="campanha-vm-premio-item">
                <!-- marcador da linha do tempo — só aparece no mobile (ver CSS); no desktop os 3 cards já
                     ficam lado a lado e a linha do tempo não faz sentido -->
                <div class="campanha-vm-premio-marcador">
                  <!-- linhas em cima e embaixo do mesmo tamanho (flex:1 cada) fazem a bolinha ficar
                       centralizada na altura do card, em vez de colada no topo -->
                  <div class="campanha-vm-premio-linha campanha-vm-premio-linha-topo"></div>
                  <div
                      class="campanha-vm-premio-dot"
                      :class="{ 'campanha-vm-premio-dot--atual': isClassificacaoAtualCampanhaVendaMargem(classificacao) }"
                      :style="isClassificacaoAtualCampanhaVendaMargem(classificacao) ? {
                        background: `rgb(${classificacaoCorRGB(classificacao).join(',')})`,
                        boxShadow: `0 0 0 3px rgba(${classificacaoCorRGB(classificacao).join(',')}, 0.25)`,
                      } : null"
                  ></div>
                  <div class="campanha-vm-premio-linha campanha-vm-premio-linha-baixo"></div>
                </div>
                <div
                    class="pa-3 campanha-vm-box campanha-vm-premio campanha-vm-premio-conteudo"
                    :class="{ 'campanha-vm-premio--atual': isClassificacaoAtualCampanhaVendaMargem(classificacao) }"
                >
                  <v-chip x-small :color="classificacaoCor(classificacao)" dark class="font-weight-bold mb-2">{{ classificacao }}</v-chip>
                  <div
                      v-for="item in premiosCampanhaVendaMargem[classificacao]"
                      :key="item.nome"
                      class="d-flex align-center mb-2"
                      style="gap: 8px;"
                  >
                    <v-avatar size="28" :style="{ background: `rgba(${classificacaoCorRGB(classificacao).join(',')}, 0.15)` }">
                      <v-icon size="16" :style="{ color: `rgb(${classificacaoCorRGB(classificacao).join(',')})` }">{{ item.icone }}</v-icon>
                    </v-avatar>
                    <span style="font-size: 12px;">{{ item.nome }}</span>
                  </div>
                  <div v-if="isClassificacaoAtualCampanhaVendaMargem(classificacao)" class="campanha-vm-premio-atual-tag">
                    <v-icon size="14" color="#023449" class="mr-1">mdi-map-marker</v-icon>
                    Atualmente você está aqui
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- DICAS PARA GANHAR MAIS PONTOS -->
            <div class="campanha-vm-box-titulo mb-2 mt-4">Dicas para ganhar mais pontos</div>
            <v-carousel
                v-model="campanhaVendaMargemDicaAtual"
                height="185"
                hide-delimiters
                :show-arrows="false"
                cycle
                interval="20000"
                transition="fade-transition"
                reverse-transition="fade-transition"
                class="campanha-vm-dicas"
            >
              <v-carousel-item v-for="(dica, i) in dicasCampanhaVendaMargem" :key="i">
                <div class="pa-4 campanha-vm-box campanha-vm-dica-slide">
                  <div class="d-flex align-center justify-space-between mb-3">
                    <div class="d-flex align-center" style="gap: 10px; min-width: 0;">
                      <div class="campanha-vm-dica-icone">
                        <v-icon color="white" size="16">{{ dica.icone }}</v-icon>
                      </div>
                      <span class="font-weight-bold" style="font-size: 13px; line-height: 1.3; color: #023449; white-space: pre-line;">{{ dica.titulo }}</span>
                    </div>
                    <div class="d-flex align-center flex-shrink-0" style="gap: 2px;">
                      <v-btn icon x-small class="campanha-vm-dica-nav" @click="campanhaVendaMargemDicaAnterior">
                        <v-icon size="16">mdi-chevron-left</v-icon>
                      </v-btn>
                      <span class="text--secondary" style="font-size: 11px; white-space: nowrap;">{{ i + 1 }}/{{ dicasCampanhaVendaMargem.length }}</span>
                      <v-btn icon x-small class="campanha-vm-dica-nav" @click="campanhaVendaMargemProximaDica">
                        <v-icon size="16">mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <div class="text--secondary" style="font-size: 12px; line-height: 1.5;">{{ dica.texto }}</div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </template>
        </v-card>

        <!-- DIALOG: CARTAZ DE LANÇAMENTO DA CAMPANHA DE VENDAS (arte oficial do marketing) — abre uma vez
             só (ver abrirCartazCampanhaVendasSeNaoVisto/watch de dialogCampanhaVendasCartaz). Só grava no
             localStorage (pra nunca mais abrir sozinho) se o vendedor marcar a flag "Não exibir novamente"
             antes de fechar — se só fechar sem marcar, volta a aparecer na próxima vez que carregar a página -->
        <v-dialog v-model="dialogCampanhaVendasCartaz" :max-width="$vuetify.breakpoint.smAndDown ? 460 : 900">
          <v-card>
            <div style="position: relative; line-height: 0;">
              <v-img :src="campanhaVendasCartaz" alt="Campanha de Vendas 2026 — Construindo Campeões" />
              <v-btn icon dark class="campanha-vm-cartaz-fechar" @click="dialogCampanhaVendasCartaz = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-actions class="px-4">
              <v-checkbox
                  v-model="campanhaVendasCartazNaoExibirNovamente"
                  label="Não exibir novamente"
                  hide-details
                  dense
                  class="ma-0"
              ></v-checkbox>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG: COMO FUNCIONA A CAMPANHA DE VENDAS -->
        <v-dialog v-model="dialogRegrasCampanhaVendaMargem" max-width="480" scrollable>
          <!-- título e "Fechar" fixos, só o meio rola — sem isso, com o conteúdo mais alto (2 boxes +
               tabela), o card inteiro passava a rolar junto e o botão "Fechar" ficava perdido lá embaixo -->
          <v-card style="max-height: 85vh; display: flex; flex-direction: column;">
            <v-card-title class="d-flex align-center campanha-vm-regras-titulo flex-shrink-0" style="gap: 10px;">
              <v-icon color="white" size="20">mdi-book-open-variant</v-icon>
              Como funciona a campanha
            </v-card-title>
            <v-card-text class="pt-4">
              <!-- REGRA 1 -->
              <div class="mb-3 campanha-vm-regras-box">
                <div class="d-flex align-center mb-2" style="gap: 10px;">
                  <div class="campanha-vm-dica-icone"><v-icon color="white" size="16">{{ regra1ExplicacaoCampanhaVendaMargem.icone }}</v-icon></div>
                  <span class="font-weight-bold" style="font-size: 14px; color: #023449;">{{ regra1ExplicacaoCampanhaVendaMargem.titulo }}</span>
                </div>
                <div class="text--secondary mb-2" style="font-size: 13px; line-height: 1.5;">{{ regra1ExplicacaoCampanhaVendaMargem.texto }}</div>

                <v-btn
                    text
                    small
                    color="#0369a1"
                    class="pl-0 mb-1"
                    style="text-transform: none;"
                    @click="exibirTabelaRegra1CampanhaVendaMargem = !exibirTabelaRegra1CampanhaVendaMargem"
                >
                  <v-icon size="16" class="mr-1">{{ exibirTabelaRegra1CampanhaVendaMargem ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  {{ exibirTabelaRegra1CampanhaVendaMargem ? 'Ocultar tabela de cupons' : 'Ver tabela de cupons por classificação' }}
                </v-btn>

                <div v-if="exibirTabelaRegra1CampanhaVendaMargem">
                  <div v-for="grupo in tabelaRegra1CampanhaVendaMargem" :key="grupo.classificacao" class="mb-2 campanha-vm-regra1-grupo">
                    <div class="d-flex align-center mb-1" style="gap: 6px;">
                      <v-chip x-small :color="classificacaoCor(grupo.classificacao)" dark class="font-weight-bold">{{ grupo.classificacao }}</v-chip>
                      <span class="font-weight-medium" style="font-size: 12px;">{{ grupo.atingimento }} de atingimento</span>
                    </div>
                    <div v-for="faixa in grupo.faixas" :key="faixa.margem" class="d-flex justify-space-between campanha-vm-regra1-linha">
                      <span class="text--secondary" style="font-size: 11px;">Margem {{ faixa.margem }}</span>
                      <span class="font-weight-bold" style="font-size: 11px; color: #023449;">{{ faixa.cupons }} cupons</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BLOCOS A-F — mesma caixa do box da Regra 1, pra dar simetria às duas seções do dialog, com
                   uma divisória sutil entre os blocos (sem ela os 6 itens viravam um bloco de texto só) -->
              <div class="campanha-vm-regras-box">
                <div class="font-weight-bold mb-2" style="font-size: 13px; color: #023449;">Cupons extras por bloco</div>
                <div v-for="item in blocosExplicacaoCampanhaVendaMargem" :key="item.bloco" class="d-flex campanha-vm-bloco-linha" style="gap: 10px;">
                  <div class="campanha-vm-dica-icone"><v-icon color="white" size="16">{{ item.icone }}</v-icon></div>
                  <div class="pb-3">
                    <div class="font-weight-bold mb-1" style="font-size: 13px; color: #023449;">{{ item.bloco }}</div>
                    <div class="text--secondary" style="font-size: 12px; line-height: 1.5;">{{ item.texto }}</div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider class="flex-shrink-0"></v-divider>
            <v-card-actions class="flex-shrink-0">
              <v-spacer></v-spacer>
              <v-btn text @click="dialogRegrasCampanhaVendaMargem = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Card Campanha de Bonificação E-book -->
        <v-card v-if="abaVendedorAtiva === 'campanha-ebook' && podeVerCampanhaEbookVendedor" class="mb-6 pa-4 ebook-campaign-card" elevation="1" style="border-radius: 12px; border: 1px solid #e0e0e0;">
          <template v-if="carregandoEbook">
            <div class="d-flex align-center mb-4">
              <v-skeleton-loader type="avatar" class="mr-3"></v-skeleton-loader>
              <div class="flex-grow-1">
                <v-skeleton-loader type="text" max-width="220" class="mb-1"></v-skeleton-loader>
                <v-skeleton-loader type="text" max-width="160"></v-skeleton-loader>
              </div>
            </div>

            <v-skeleton-loader type="image" height="72" class="mb-4" style="border-radius: 8px;"></v-skeleton-loader>

            <v-row dense class="mb-1">
              <v-col v-for="n in 3" :key="n" cols="4">
                <v-skeleton-loader type="image" height="56" class="mb-3" style="border-radius: 8px;"></v-skeleton-loader>
              </v-col>
            </v-row>

            <v-skeleton-loader type="image" height="8" class="mb-4" style="border-radius: 4px;"></v-skeleton-loader>

            <v-skeleton-loader type="text" max-width="140" class="mb-2"></v-skeleton-loader>
            <div class="d-flex flex-wrap mb-4" style="gap: 6px;">
              <v-skeleton-loader v-for="n in 6" :key="n" type="image" width="84" height="40" style="border-radius: 8px;"></v-skeleton-loader>
            </div>

            <v-skeleton-loader type="image" height="48" style="border-radius: 8px;"></v-skeleton-loader>

            <p class="text-center text--secondary mt-4 mb-0" style="font-size: 12px;">
              Calculando ranking da campanha, isso pode levar alguns segundos...
            </p>
          </template>

          <template v-else>
            <div class="mb-4 ebook-card-header">
              <div class="d-flex align-center ebook-card-header-row">
                <v-avatar :size="$vuetify.breakpoint.xsOnly ? 56 : 40" color="#E6F1FB" class="mr-3 ebook-card-header-avatar">
                  <v-icon color="#185FA5" :size="$vuetify.breakpoint.xsOnly ? 26 : 20">mdi-book-open-page-variant</v-icon>
                </v-avatar>
                <div class="flex-grow-1 ebook-header-text">
                  <div class="font-weight-medium ebook-header-title" style="font-size: 15px;">Educa Comercial Ivaiporã</div>
                  <div class="text--secondary ebook-header-subtitle" style="font-size: 13px;">Campanha de bonificação E-book · {{ periodoCampanhaEbookLabel }}</div>
                </div>
                <v-chip
                    v-if="ebookRanking && ebookRanking.flag_premiado === 'T'"
                    small
                    color="#EAF3DE"
                    text-color="#3B6D11"
                    class="font-weight-medium ebook-header-chip"
                >
                  Elegível à premiação
                </v-chip>
              </div>
            </div>

            <template v-if="!ebookRanking">
              <div class="d-flex align-center pa-4 mb-4" style="background: #f7f7f5; border-radius: 8px;">
                <v-avatar size="56" color="white" class="mr-4" style="border: 1px solid #e0e0e0;">
                  <v-icon size="26" color="#9a988f">mdi-book-open-page-variant</v-icon>
                </v-avatar>
                <div>
                  <div style="font-size: 20px; font-weight: 500;">0 pontos</div>
                  <div class="text--secondary" style="font-size: 13px;">Nenhuma venda de e-book pontuada este mês</div>
                </div>
              </div>
            </template>

            <template v-else>
              <!-- HERO -->
              <div class="d-flex align-center pa-4 mb-4" style="background: #f7f7f5; border-radius: 8px;">
                <div
                    class="d-flex flex-column align-center justify-center mr-4"
                    :style="{ width: '56px', height: '56px', borderRadius: '50%', background: medalEbook.bg, flexShrink: 0 }"
                >
                  <v-icon :color="medalEbook.text" size="18">{{ medalEbook.icon }}</v-icon>
                  <span v-if="ebookRanking.flag_top25 === 'T'" :style="{ fontSize: '13px', fontWeight: 500, color: medalEbook.text }">{{ ebookRanking.posicao }}º</span>
                </div>
                <div>
                  <div style="font-size: 24px; font-weight: 500;">{{ ebookRanking.total_pontos }} pontos</div>
                  <div class="text--secondary" style="font-size: 13px;">
                    {{ ebookRanking.flag_top25 === 'T' ? 'posição no ranking geral da rede' : 'pontos no mês' }}
                  </div>
                </div>
              </div>

              <!-- STATS -->
              <v-row dense class="mb-1">
                <v-col cols="4">
                  <div class="pa-3 mb-3" style="background: #f7f7f5; border-radius: 8px;">
                    <div class="text--secondary" style="font-size: 12px;">E-books vendidos</div>
                    <div style="font-size: 18px; font-weight: 500;">{{ ebookRanking.total_qtd_ebook }}</div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="pa-3 mb-3" style="background: #f7f7f5; border-radius: 8px;">
                    <div class="text--secondary" style="font-size: 12px;">Vendas elegíveis</div>
                    <div style="font-size: 18px; font-weight: 500;">{{ ebookRanking.total_vendas }}</div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="pa-3 mb-3" style="background: #f7f7f5; border-radius: 8px;">
                    <div class="text--secondary" style="font-size: 12px;">Projeção do mês</div>
                    <div style="font-size: 18px; font-weight: 500;">{{ ebookRanking.projecao_pontos }} pts</div>
                  </div>
                </v-col>
              </v-row>
            </template>

            <!-- MENSAGEM -->
            <div class="d-flex pa-3 mb-4" style="background: #f7f7f5; border-radius: 8px; gap: 10px;">
              <v-icon color="#185FA5" size="18">mdi-lightbulb-on-outline</v-icon>
              <span class="text--secondary" style="font-size: 13px;">{{ mensagemEbook }}</span>
            </div>

            <!-- ESCADA DE PREMIAÇÃO -->
            <div class="text--secondary mb-2" style="font-size: 13px;">Premiação da campanha</div>
            <div class="ebook-ladder-track" :class="{ 'mb-4': ebookRanking }">
              <div
                  v-for="(premio, i) in premiacaoEbook"
                  :key="i"
                  class="ebook-ladder-pill text-center"
                  :style="{
                  background: isPosicaoEbookAtual(i + 1) ? '#E6F1FB' : '#f7f7f5',
                  border: isPosicaoEbookAtual(i + 1) ? '2px solid #378ADD' : 'none'
                }"
              >
                <div :style="{ fontSize: '12px', color: isPosicaoEbookAtual(i + 1) ? '#185FA5' : '#8a8980' }">{{ i + 1 }}º</div>
                <div class="ebook-ladder-valor" style="font-weight: 500;">{{ formatarMoeda(premio) }}</div>
              </div>
            </div>

            <!-- PROGRESSO -->
            <div v-if="ebookRanking && ebookRanking.flag_top25 === 'T'">
              <div class="d-flex justify-space-between mb-1" style="font-size: 13px;">
                <span class="text--secondary">{{ progressoEbookLabel }}</span>
                <span class="font-weight-medium">{{ progressoEbookPct }}%</span>
              </div>
              <v-progress-linear :value="progressoEbookPct" height="8" rounded background-color="#f0efe8" color="#378ADD" />
            </div>
          </template>
        </v-card>

        <!-- Loading -->
        <div v-if="abaVendedorAtiva === 'metricas-vendas' && carregando" class="text-center pa-8">
          <v-progress-circular indeterminate color="primary" size="60" width="6"></v-progress-circular>
          <p class="mt-4 grey--text">Carregando Dashboard...</p>
        </div>

        <!-- Dashboard Content -->
        <div v-else-if="abaVendedorAtiva === 'metricas-vendas' && !carregando">
          <!-- Cards de Métricas Principais -->
          <v-row class="mb-6">
            <!-- Atingimento do Dia -->
            <v-col cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #082f49 0%, #0c4a6e 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-trending-up</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-calendar-today</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.peratingimentoad_new }}%</h1>
                  <p class="white--text font-weight-medium mb-3">Atingimento Diário da Meta</p>
                  <v-progress-linear :value="dashboard.peratingimentoad_new" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemAtingimentoDia() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Margem do Dia -->
            <v-col cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-percent</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-calendar-today</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.margemad }}%</h1>
                  <p class="white--text font-weight-medium mb-3">Margem do Dia</p>
                  <v-progress-linear :value="dashboard.margemad" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemMargemDia() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Atingimento Acumulado -->
            <v-col cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #a8e063 0%, #56ab2f 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-trending-up</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-chart-line-variant</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.perprojecao }}%</h1>
                  <p class="white--text font-weight-medium mb-3">Atingimento Acumulado da Meta</p>
                  <v-progress-linear :value="dashboard.perprojecao" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemProjecao() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Margem Acumulada -->
            <v-col cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #e6a100 0%, #e67f00 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-percent</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-label-percent</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.margemac }}%</h1>
                  <p class="white--text font-weight-medium mb-3">Margem Acumulada</p>
                  <v-progress-linear :value="dashboard.margemac" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemMargem() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Atingimento Total -->
            <v-col cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #c81111 0%, #951015 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-target</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-bullseye-arrow</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.peratingimentoac }}%</h1>
                  <p class="white--text font-weight-medium mb-3">Atingimento Total da Meta</p>
                  <v-progress-linear :value="dashboard.peratingimentoac" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemAtingimento() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Venda Campanha -->
            <v-col cols="12" md="6" lg="4" xl="2" v-if="dataCampanha(getDataAtual())">
              <v-card height="240" elevation="3" class="pa-2 sm-pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #6096A6 0%, #74B6C9 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-currency-usd</v-icon>
                </div>
                <div class="pa-6 text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-sale-outline</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ vendaCampanha |
                      formataDinheiro }}</h1>
                  <p class="white--text font-weight-medium mb-3">Venda Campanha Queima de Estoque</p>
                  <!-- <v-progress-linear
                      :value="dashboard.margemac"
                      height="12"
                      rounded
                      color="white"
                      background-color="rgba(255,255,255,0.3)"
                      class="mb-3"
                  ></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemMargem() }}
                  </v-chip> -->
                </div>
              </v-card>
            </v-col>

            <!-- Bonificação Campanha -->
            <v-col cols="12" md="6" lg="4" xl="2" v-if="dataCampanha(getDataAtual())">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #6096A6 0%, #74B6C9 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-currency-usd</v-icon>
                </div>
                <div class="pa-6 text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-sack-outline</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ bonificacaoCampanha | formataDinheiro }}
                  </h1>
                  <p class="white--text font-weight-medium mb-3">Bonificação Campanha Queima de Estoque</p>
                  <!-- <v-progress-linear
                      :value="dashboard.margemac"
                      height="12"
                      rounded
                      color="white"
                      background-color="rgba(255,255,255,0.3)"
                      class="mb-3"
                  ></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemMargem() }}
                  </v-chip> -->
                </div>
              </v-card>
            </v-col>

            <!-- Projeção -->
            <v-col v-if="false" cols="12" md="6" lg="4" xl="2">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #a8e063 0%, #56ab2f 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-trending-up</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-2">mdi-chart-line-variant</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-1">{{ dashboard.perprojecao }}%</h1>
                  <p class="white--text font-weight-medium mb-1">Venda Projetada</p>
                  <div class="d-flex justify-center mb-3">
                    <v-rating :value="getProjecaoStars()" color="white" background-color="rgba(255,255,255,0.3)" dense
                              half-increments readonly size="25"></v-rating>
                  </div>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemProjecao() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>

            <!-- Bonificação -->
            <v-col cols="12" md="6" lg="4" xl="2" v-if="isMesEAnoAtual(dtdia)">
              <v-card height="240" elevation="3" class="pa-4 position-relative overflow-hidden metric-card"
                      style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); border-radius: 12px;">
                <div class="card-bg-icon">
                  <v-icon size="120" style="opacity: 0.1; color: white;">mdi-gift</v-icon>
                </div>
                <div class="position-relative text-center">
                  <v-icon size="50" color="white" class="mb-3">mdi-gift-outline</v-icon>
                  <h1 class="white--text font-weight-bold display-2 mb-2">{{ dashboard.bonificacao | formataDinheiro }}
                  </h1>
                  <!--                  <p class="white&#45;&#45;text font-weight-medium mb-3">Nível de Bonificação</p>-->
                  <p class="white--text font-weight-medium mb-3">Projeção de Bonificação</p>
                  <v-progress-linear :value="dashboard.perbonificacao" height="12" rounded color="white"
                                     background-color="rgba(255,255,255,0.3)" class="mb-3"></v-progress-linear>
                  <v-chip small color="rgba(255,255,255,0.2)" class="white--text">
                    {{ getMensagemBonificacao() }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>

        </template>

        <!-- placeholder da visão gerencial sem vendedor selecionado -->
        <v-card v-else flat class="text-center pa-8 campanha-vm-card">
          <v-icon size="64" color="#94a3b8">mdi-account-search-outline</v-icon>
          <h3 class="mt-4 mb-1" style="color: #023449;">Selecione um vendedor</h3>
          <p class="grey--text text--darken-1 mb-0">Escolha um vendedor no filtro acima para carregar a dashboard dele.</p>
        </v-card>

      </v-col>

      <!-- Dashboard para outros usuários -->
      <v-col v-else cols="12" class="pa-0">
        <v-card class="pa-6 primary" dark>
          <h3 class="font-weight-bold mb-2">
            Bem-vindo, {{ usuario.usuario }} 👋
          </h3>
          <v-card-text class="text-subtitle-1 pa-0">
            Use o menu lateral para acessar as principais áreas do sistema.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { PREMIOS_CAMPANHA_VENDA_MARGEM, ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM } from "@/constants/campanhaVendaMargemPremios";
import { REGRA1_EXPLICACAO_CAMPANHA_VENDA_MARGEM, TABELA_REGRA1_CAMPANHA_VENDA_MARGEM, BLOCOS_EXPLICACAO_CAMPANHA_VENDA_MARGEM, DICAS_CAMPANHA_VENDA_MARGEM } from "@/constants/campanhaVendaMargemRegras";
import campanhaVendasCartazVertical from "@/assets/campanha-vendas-2026-cartaz-vertical.jpeg";
import campanhaVendasCartazHorizontal from "@/assets/campanha-vendas-2026-cartaz-horizontal.jpeg";
import CampanhaVendaMargemFaixas from "./CampanhaVendaMargemFaixas.vue";

// chave do localStorage que marca se o vendedor já viu o cartaz de lançamento da campanha — troque o valor
// (ex: "v2") se subir uma arte nova e quiser que todo mundo veja de novo, mesmo quem já fechou a v1
const CAMPANHA_VENDAS_CARTAZ_VISTO_KEY = "campanha_vendas_2026_cartaz_visto_v1";

export default {
  name: "DashboardBonificacao",
  components: { CampanhaVendaMargemFaixas },
  data: () => ({
    dtdia: new Date().toISOString().split("T")[0],
    search: null,
    vendedores: [],
    idvendedor: null,
    vendaCampanha: 0,
    bonificacaoCampanha: 0,
    dashboard: {
      peratingimentoac: 0,
      perprojecao: 0,
      bonificacao: 0,
      perbonificacao: 0,
      mensagem: null,
      margemac: 0,
      vendedor: '',
      peratingimentoad: 0,
      peratingimentoad_new: 0,
      margemad: 0,
    },
    rankingCampanha: { listaVendedores: [] },
    carregando: false,
    carregandoVendedores: false,
    aguardarBusca: null,
    ebookRanking: null,
    carregandoEbook: false,
    premiacaoEbook: [1000, 900, 800, 700, 600, 500, 400, 300, 200, 100],
    campanhaVendaMargemVendedorAcumulado: null,
    campanhaVendaMargemVendedorMeses: [],
    // começa true (não false) de propósito: as rotas de acumulado/meses demoram um pouco mais pra
    // responder, e o card decide o que mostrar com base em "!campanhaVendaMargemVendedorAcumulado" — se
    // esse loading começasse false, a primeira renderização cairia direto no estado "vendedor ainda não
    // pontuou" (falso negativo) antes da requisição sequer voltar, e só trocaria pro card de verdade
    // quando os dados chegassem. Setado como true aqui garante que o skeleton apareça desde o primeiro
    // render, sem essa piscada
    carregandoCampanhaVendaMargemVendedor: true,
    dialogRegrasCampanhaVendaMargem: false,
    exibirTabelaRegra1CampanhaVendaMargem: false,
    campanhaVendaMargemDicaAtual: 0,
    dialogCampanhaVendasCartaz: false,
    campanhaVendasCartazNaoExibirNovamente: false,
    campanhaVendasCartazVertical,
    campanhaVendasCartazHorizontal,
    // aba ativa da navegação do vendedor (Campanha de Vendas / Campanha E-book / Métricas de Vendas) — o
    // valor não leva o "#" do href do v-tab correspondente, o Vuetify remove isso sozinho do v-model.
    // Ajustado no created() se a aba padrão não estiver disponível pra esse vendedor (sem permissão)
    abaVendedorAtiva: 'campanha-vendas',
  }),

  computed: {
    ...mapState(["backendUrl", "usuario"]),
    // true só pra quem tem a permissão master (visão gerencial) e ainda não escolheu nenhum vendedor no
    // filtro — nesse caso a dashboard fica escondida (mostra um placeholder pedindo pra selecionar
    // alguém), já que mostrar dados sem saber de qual vendedor não faz sentido nessa visão. Pro vendedor
    // comum (idgrupo 7, sem a permissão master) isso é sempre false: ele nunca vê o filtro, então sempre
    // vê a própria dashboard direto, como sempre foi
    precisaSelecionarVendedor() {
      return this.permissao('dashboard_vendedor_filtro_master') && !this.idvendedor;
    },
    // quem tem a permissão master de filtro de vendedor (dashboard_vendedor_filtro_master) enxerga TODAS
    // as seções da dashboard do vendedor, mesmo sem ter a permissão individual de cada uma — é o próprio
    // propósito da visão gerencial: poder ver como qualquer vendedor está vendo, inclusive a Campanha de
    // Vendas do 2º semestre e a Campanha E-book
    podeVerCampanhaVendaMargemVendedor() {
      return this.permissao('dashboard_ranking_campanha_venda_margem_vendedor') || this.permissao('dashboard_vendedor_filtro_master');
    },
    podeVerCampanhaEbookVendedor() {
      return this.permissao('dashboard_ranking_bonificacao_ebook') || this.permissao('dashboard_vendedor_filtro_master');
    },
    // nome de exibição de quem está sendo visualizado pelo filtro master — usa o nome que já veio na
    // resposta de getDashboardData (this.dashboard.vendedor), em vez de procurar no array local
    // `vendedores`, que é esvaziado pela busca do autocomplete assim que o texto digitado muda ou é limpo
    // após a seleção; null quando não há filtro ativo, pra cair de volta na saudação padrão
    nomeVendedorSelecionado() {
      return (this.idvendedor && this.dashboard && this.dashboard.vendedor) ? this.dashboard.vendedor : null;
    },
    // entrada do mês corrente dentro de campanhaVendaMargemVendedorMeses — usada pra separar, no total de
    // cupons do HERO, o que já é garantido (meses fechados) do que ainda pode mudar (mês em andamento)
    campanhaVendaMargemMesAtualResumo() {
      const mesAtual = new Date().toISOString().slice(0, 7);
      return this.campanhaVendaMargemVendedorMeses.find((mes) => mes.mes === mesAtual) || null;
    },
    // o Total Geral (campanhaVendaMargemVendedorAcumulado.total_cupons) já soma o mês corrente junto com os
    // meses fechados — mas o mês corrente ainda pode mudar (pra cima ou pra baixo) até fechar, então não é
    // correto chamar esse número inteiro de "garantido". Aqui subtrai a parte do mês corrente, sobrando só
    // os cupons de meses já fechados (esses sim, não mudam mais)
    campanhaVendaMargemCuponsGarantidos() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      if (!ac) return 0;
      const cuponsMesAtual = this.campanhaVendaMargemMesAtualResumo ? (this.campanhaVendaMargemMesAtualResumo.total_cupons || 0) : 0;
      return Math.max(0, (ac.total_cupons || 0) - cuponsMesAtual);
    },
    campanhaVendaMargemCuponsMesAtual() {
      return this.campanhaVendaMargemMesAtualResumo ? (this.campanhaVendaMargemMesAtualResumo.total_cupons || 0) : 0;
    },
    // em telas menores a arte vertical (A4) aproveita melhor o espaço; a horizontal é pensada pra telas
    // maiores (notebook/desktop) — mesmo limiar usado no max-width do v-dialog do cartaz
    campanhaVendasCartaz() {
      return this.$vuetify.breakpoint.smAndDown
          ? this.campanhaVendasCartazVertical
          : this.campanhaVendasCartazHorizontal;
    },
    avaliacaoAtual() {
      return this.avaliarDesempenhoVendedor(this.dashboard);
    },
    cenarioEbook() {
      if (this.isPrimeiroMesCampanhaEbook(this.getDataAtual())) return 'C';
      if (this.ebookRanking && this.ebookRanking.flag_top25 === 'T') return 'A';
      return 'B';
    },
    mensagemEbook() {
      if (!this.ebookRanking) {
        return 'Toda venda de e-book conta pontos. Faça sua primeira venda do mês e entre no ranking.';
      }
      const r = this.ebookRanking;
      if (this.cenarioEbook === 'C') {
        return `Primeiro mês da campanha! No ritmo atual, sua projeção é de ${r.projecao_pontos} pontos até o fim do mês.`;
      }
      if (r.flag_premiado === 'T') {
        return r.posicao === 1
            ? `Parabéns! Você está em 1º lugar e concorrendo ao prêmio de ${this.formatarMoeda(this.premiacaoEbook[0])}.`
            : `Você está no Top 10, concorrendo a ${this.formatarMoeda(this.premiacaoEbook[r.posicao - 1])}. Continue vendendo para subir de posição.`;
      }
      if (r.flag_top25 === 'T') {
        return `Você está entre os 25 melhores da rede. Faltam ${r.pontos_faltam_top10} pontos para entrar no Top 10 e concorrer à premiação.`;
      }
      return `Continue vendendo e-books para entrar no Top 25. No ritmo atual, sua projeção é de ${r.projecao_pontos} pontos até o fim do mês.`;
    },
    medalEbook() {
      const neutro = { bg: '#f7f7f5', text: '#8a8980', icon: 'mdi-flag-outline' };
      if (!this.ebookRanking) return neutro;
      const pos = this.ebookRanking.posicao;
      if (pos === 1) return { bg: '#FAEEDA', text: '#854F0B', icon: 'mdi-trophy' };
      if (pos <= 3) return { bg: '#FAEEDA', text: '#854F0B', icon: 'mdi-medal' };
      if (pos <= 10) return { bg: '#E6F1FB', text: '#185FA5', icon: 'mdi-star' };
      if (pos <= 25) return { bg: '#EAF3DE', text: '#3B6D11', icon: 'mdi-flag' };
      return neutro;
    },
    progressoEbookPct() {
      if (!this.ebookRanking) return 0;
      const r = this.ebookRanking;
      if (r.flag_premiado === 'T') {
        if (r.posicao === 1) return 100;
        return Math.min(100, Math.max(15, 100 - r.pontos_faltam_proxima_posicao * 8));
      }
      const denominador = r.total_pontos + r.pontos_faltam_top10;
      return denominador > 0 ? Math.round((r.total_pontos / denominador) * 100) : 0;
    },
    progressoEbookLabel() {
      if (!this.ebookRanking) return '';
      const r = this.ebookRanking;
      if (r.flag_premiado === 'T') {
        return r.posicao === 1
            ? 'Você é o 1º colocado da campanha'
            : `Faltam ${r.pontos_faltam_proxima_posicao} pontos para a posição acima`;
      }
      return `Faltam ${r.pontos_faltam_top10} pontos para entrar no Top 10`;
    },
    periodoCampanhaEbookLabel() {
      const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      const hoje = new Date();
      return `${meses[hoje.getMonth()]} ${hoje.getFullYear()}`;
    },

    // --- Campanha de Vendas 2ª Edição (venda e margem) — visão do vendedor ---

    premiosCampanhaVendaMargem() {
      return PREMIOS_CAMPANHA_VENDA_MARGEM;
    },
    // só as classificações que têm prêmio de fato (NÃO ATINGIU fica de fora da "escada" de prêmios)
    ordemClassificacaoPremiosCampanhaVendaMargem() {
      return ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM.filter((classificacao) => PREMIOS_CAMPANHA_VENDA_MARGEM[classificacao]);
    },
    regra1ExplicacaoCampanhaVendaMargem() {
      return REGRA1_EXPLICACAO_CAMPANHA_VENDA_MARGEM;
    },
    tabelaRegra1CampanhaVendaMargem() {
      return TABELA_REGRA1_CAMPANHA_VENDA_MARGEM;
    },
    blocosExplicacaoCampanhaVendaMargem() {
      return BLOCOS_EXPLICACAO_CAMPANHA_VENDA_MARGEM;
    },
    dicasCampanhaVendaMargem() {
      return DICAS_CAMPANHA_VENDA_MARGEM;
    },
    // lista de todos os períodos (cada mês + Total Geral por último) já carregados —
    // cada item já traz os próprios "pontos por regra" prontos, pra não recalcular no template. Marca o
    // mês corrente como `emAndamento`: ele ainda não fechou, então a linha colapsada não pode exibir a
    // classificação (OURO/PRATA/BRONZE/NÃO ATINGIU) como se fosse definitiva — pra quem só olha por cima
    // sem expandir, um "NÃO ATINGIU" vermelho no mês que ainda está rolando parece um veredito final e
    // desanima à toa, quando na verdade ainda dá tempo de vender e mudar esse resultado
    campanhaVendaMargemHistorico() {
      const mesAtual = new Date().toISOString().slice(0, 7);
      const periodos = this.campanhaVendaMargemVendedorMeses.map((mes) => (
        { chave: mes.mes, label: mes.mes_formatado, icone: 'mdi-calendar-month-outline', dados: mes, emAndamento: mes.mes === mesAtual }
      ));
      periodos.push({ chave: 'acumulado', label: 'Total Geral', icone: 'mdi-chart-timeline-variant', dados: this.campanhaVendaMargemVendedorAcumulado, emAndamento: false });
      return periodos.map((periodo) => ({
        ...periodo,
        pontos: this.campanhaVendaMargemPontosPorRegraDe(periodo.dados),
      }));
    },
    // mensagem motivacional — só faz sentido pro período "Acumulado", já que é o que de fato determina a
    // classificação/prêmio real do vendedor na campanha
    campanhaVendaMargemMensagem() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      if (!ac) {
        return 'Toda venda conta pontos. Comece a pontuar na campanha esse mês.';
      }
      if (!ac.proxima_classificacao) {
        return 'Parabéns! Você está na classificação OURO, o mais alto nível da campanha. Mantenha o ritmo para não cair de classificação.';
      }
      // "faixa premiada com" em vez de "e concorrer a": a campanha ainda não fechou, então alcançar a
      // próxima classificação agora não garante que ele ainda estará nela quando a campanha terminar de
      // verdade — a frase descreve os prêmios da faixa, sem prometer que ele vai ganhá-los
      const premios = PREMIOS_CAMPANHA_VENDA_MARGEM[ac.proxima_classificacao] || [];
      const premiosTexto = premios.length ? `, faixa premiada com: ${premios.map((p) => p.nome).join(', ')}` : '';
      return `Faltam ${this.formatarPercentual(ac.perc_falta_proxima_classificacao)} de atingimento da meta acumulada para alcançar ${ac.proxima_classificacao}${premiosTexto}.`;
    },
    // melhor classificação já alcançada nos meses FECHADOS (exclui o mês corrente, ainda em andamento) —
    // null se a campanha ainda não tem nenhum mês fechado (ex: julho, o primeiro mês). Usada só pra dar
    // contexto na mensagem de projeção: "fecha em BRONZE" motiva diferente se os meses anteriores foram
    // todos OURO (é uma queda, precisa reagir) do que se foram NÃO ATINGIU (fechar em BRONZE já é evolução)
    campanhaVendaMargemMelhorClassificacaoMesesFechados() {
      const mesAtual = new Date().toISOString().slice(0, 7);
      const fechados = this.campanhaVendaMargemVendedorMeses.filter((mes) => mes.mes < mesAtual);
      if (!fechados.length) return null;
      return fechados.reduce((melhor, mes) => (
        ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM.indexOf(mes.classificacao) > ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM.indexOf(melhor)
          ? mes.classificacao
          : melhor
      ), fechados[0].classificacao);
    },
    // mensagem de projeção do ritmo do mês corrente, baseada em classificacao_projetada (backend, calculada
    // a partir do fator de dias úteis ponderados já decorridos vs. total do mês) — null quando o mês corrente
    // ainda não tem nenhuma venda (backend não consegue projetar ritmo sem nenhum dado), então não aparece
    // no template. Compara com campanhaVendaMargemMelhorClassificacaoMesesFechados: se a projeção do mês é
    // pior que o melhor mês já fechado, a mensagem vira um chamado pra reagir (em vez de "continue assim",
    // que soaria como elogio numa queda de desempenho). Nas faixas com prêmio, o texto fala do "desempenho
    // do mês" fechando "na faixa X", nunca "sua classificação" pura — classificacao_projetada é só do mês
    // corrente, não da campanha (que é o que decide o prêmio de verdade)
    campanhaVendaMargemMensagemProjecao() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      if (!ac || ac.classificacao_projetada == null) return null;
      const resumoMesAtual = this.campanhaVendaMargemMesAtualResumo;
      const nomeMes = resumoMesAtual ? resumoMesAtual.mes_formatado.split('/')[0] : 'este mês';
      const melhorAnterior = this.campanhaVendaMargemMelhorClassificacaoMesesFechados;

      if (ac.classificacao_projetada === 'NÃO ATINGIU') {
        if (melhorAnterior) {
          return `Você já fechou mês em ${melhorAnterior} nessa campanha. Ainda dá tempo de acelerar as vendas em ${nomeMes} e repetir esse resultado!`;
        }
        return `Ainda dá tempo de acelerar as vendas em ${nomeMes} e bater a meta! Cada venda a mais te deixa mais perto.`;
      }

      const indiceProjetada = ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM.indexOf(ac.classificacao_projetada);
      const indiceMelhorAnterior = melhorAnterior ? ORDEM_CLASSIFICACAO_CAMPANHA_VENDA_MARGEM.indexOf(melhorAnterior) : -1;
      if (indiceMelhorAnterior > indiceProjetada) {
        return `No ritmo atual, ${nomeMes} fecha na faixa ${ac.classificacao_projetada}, abaixo do seu ${melhorAnterior} em meses anteriores. Ainda dá tempo de acelerar e voltar pro topo!`;
      }

      return `Se você mantiver esse ritmo, o desempenho de ${nomeMes} fecha na faixa ${ac.classificacao_projetada}! Continue assim.`;
    },
    // escala máxima compartilhada entre as duas instâncias de CampanhaVendaMargemFaixas (acumulado + mês
    // corrente) — sem isso, cada barra calcularia sua própria escala a partir do seu próprio % de
    // atingimento, e BRONZE/PRATA/OURO ficariam em posições horizontais diferentes entre as duas barras. Usa
    // o maior dos dois percentuais (a mesma fórmula do componente) pra garantir que nenhum marcador atual
    // fique espremido na borda, em nenhuma das duas barras.
    campanhaVendaMargemFaixasEscalaMax() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      const mes = this.campanhaVendaMargemMesAtualResumo;
      const percentuais = [ac ? ac.peratingimento : 0, mes ? mes.peratingimento : 0];
      const maiorPercentual = Math.max(0, ...percentuais);
      return Math.max(108, Math.ceil((maiorPercentual + 8) / 5) * 5);
    },
    // círculo colorido do hero (ícone + fundo), por classificação — mesmo espírito visual do medalEbook do
    // card e-book, só que por classificação (OURO/PRATA/BRONZE) em vez de posição no ranking
    medalCampanhaVendaMargem() {
      const neutro = { bg: '#f1f5f9', text: '#64748b', icon: 'mdi-flag-outline' };
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      if (!ac) return neutro;
      const cores = {
        OURO: { bg: '#FAEEDA', text: '#854F0B', icon: 'mdi-trophy' },
        PRATA: { bg: '#ECECEC', text: '#5A5A5A', icon: 'mdi-medal' },
        BRONZE: { bg: '#F1E3DC', text: '#7A4B33', icon: 'mdi-medal-outline' },
      };
      return cores[ac.classificacao] || neutro;
    },
    // frase especial só pra NÃO ATINGIU (sem chip, sem "Classificação atual:" — ver comentário no template
    // do HERO). Pras demais classificações não precisa de nada aqui: o template já mostra "Classificação
    // atual:" + o chip direto, sem repetir o nome da classificação duas vezes
    campanhaVendaMargemTagPremio() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      if (ac && ac.classificacao === 'NÃO ATINGIU') return { tag: 'Ainda sem prêmio garantido' };
      return null;
    },
    // alerta só pra quem foi admitido depois do corte da campanha (01/10/2026) E está com classificação
    // acumulada OURO — precisa ficar bem visível porque, sem ele, o vendedor vê "OURO" no HERO e acha que
    // vai concorrer ao prêmio máximo, quando na verdade está fora do sorteio do OURO por regra (mesmo tendo
    // o desempenho pra isso). ac.admitido_tardiamente vem do backend (campanhaVendaMargemAcumularPorVendedor),
    // nunca calculado no front
    campanhaVendaMargemAlertaOuroAdmitidoTardio() {
      const ac = this.campanhaVendaMargemVendedorAcumulado;
      return !!(ac && ac.admitido_tardiamente === 'T' && ac.classificacao === 'OURO');
    },
  },

  methods: {
    // versão "suavizada" da cor de classificação, só pra NÃO ATINGIU, usada onde o status ainda pode mudar
    // (HERO e Total Geral — ambos refletem o mês corrente, que ainda está em andamento). O vermelho padrão
    // (classificacaoCor/classificacaoCorRGB do mixin) fica reservado pra status definitivos, como um mês
    // já fechado (histórico) — um vendedor no meio da campanha, ainda com dias pela frente pra reverter,
    // não devia ver uma cor de "já era" enquanto ainda dá tempo
    classificacaoCorAcumulado(classificacao) {
      return classificacao === 'NÃO ATINGIU' ? '#b45309' : this.classificacaoCor(classificacao);
    },
    classificacaoCorRGBAcumulado(classificacao) {
      return classificacao === 'NÃO ATINGIU' ? [180, 83, 9] : this.classificacaoCorRGB(classificacao);
    },
    // ícone do chip do Total Geral: relógio de progresso pra NÃO ATINGIU (ainda em apuração, sem prêmio
    // fechado), troféu pras demais classificações (já garantem alguma faixa de prêmio)
    classificacaoIconeAcumulado(classificacao) {
      return classificacao === 'NÃO ATINGIU' ? 'mdi-progress-clock' : 'mdi-trophy';
    },

    isMesEAnoAtual(dataString) {
      if (!dataString) return false;

      const [ano, mes] = dataString.split('-');
      return ano === '2025' && mes === '06';
    },

    avaliarDesempenhoVendedor(dashboard) {
      const { margemac, perprojecao, bonificacao } = dashboard;

      // Regra 1: Bonificação de R$ 1.000,00
      if (margemac >= 24 && perprojecao >= 110 && bonificacao >= 1000) {
        return {
          tipo: 'excelente',
          // mensagem: 'Parabéns! Você alcançou um desempenho excepcional e conquistou a bonificação máxima. Continue com esse excelente trabalho! 🎉🏆',
          mensagem: 'Parabéns! Você está com um desempenho excepcional. Continue com esse excelente trabalho para conquistar a bonificação máxima! 🎉🏆',
          bonificacao: 1000
        };
      }

      // Regra 2: Bonificação de R$ 500,00
      else if (margemac >= 24 && perprojecao >= 100 && bonificacao >= 500) {
        return {
          tipo: 'muito_bom',
          // mensagem: 'Ótimo trabalho! Você atingiu suas metas e conquistou uma bonificação. Mantenha o foco para alcançar a bonificação máxima! 🔥🚀',
          mensagem: 'Ótimo trabalho! Você está no caminho para receber a bonificação de R$ 500,00. Mantenha o foco para alcançar a bonificação máxima! 🔥🚀',
          bonificacao: 500
        };
      }

      // Regra 3: Margem boa, projeção excelente
      else if (margemac >= 24 && perprojecao >= 110) {
        return {
          tipo: 'motivacional',
          mensagem: 'Excelente! Sua margem está adequada e sua projeção é excepcional. Continue mantendo esse ritmo para garantir sua bonificação! 💪📈',
          bonificacao: 0
        };
      }

      // Regra 4: Margem boa, projeção boa
      else if (margemac >= 24 && perprojecao >= 100) {
        return {
          tipo: 'motivacional',
          mensagem: 'Bom trabalho! Sua margem está no caminho certo. Intensifique suas vendas para maximizar seus resultados e bonificação! 📊⚡',
          bonificacao: 0
        };
      }

      // Regra 5: Margem boa, projeção baixa
      else if (margemac >= 24 && perprojecao < 100) {
        return {
          tipo: 'alerta',
          mensagem: 'Sua margem está adequada, mas é necessário aumentar o volume de vendas para atingir sua meta. Foque em prospectar novos clientes! 📞📢',
          bonificacao: 0
        };
      }

      // Regra 6: Margem baixa, projeção excelente
      else if (margemac < 24 && perprojecao >= 110) {
        return {
          tipo: 'alerta',
          mensagem: 'Suas vendas estão excelentes! Agora concentrate-se em otimizar a sua margem para maximizar seus ganhos e bonificação. 🎯💼',
          bonificacao: 0
        };
      }

      // Regra 7: Margem baixa, projeção boa
      else if (margemac < 24 && perprojecao >= 100) {
        return {
          tipo: 'alerta',
          mensagem: 'Você está vendendo bem! Para alcançar a bonificação, trabalhe na melhoria da margem dos seus produtos. 🔧💰',
          bonificacao: 0
        };
      }

      // Regra 8: Caso geral - motivacional
      else {
        return {
          tipo: 'motivacional_geral',
          mensagem: 'Continue se esforçando! Foque em aumentar tanto o volume de vendas quanto a sua margem. Você tem potencial para alcançar grandes resultados! ✨📣',
          bonificacao: 0
        };
      }
    },

    getPrimeiroNome(nomeCompleto) {
      if (!nomeCompleto) return '';
      return nomeCompleto.trim().split(' ')[0];
    },

    getMensagemAtingimentoDia() {
      // const valor = this.dashboard.peratingimentoad || 0;
      const valor = this.dashboard.peratingimentoad_new || 0;
      if (valor >= 100) return "Dia Excepcional!";
      if (valor >= 80) return "Quase Lá";
      if (valor >= 60) return "Bom Ritmo";
      if (valor >= 40) return "Acelerando";
      return "Vamos lá!";
    },

    getMensagemMargemDia() {
      const valor = this.dashboard.margemad || 0;
      if (valor >= 24) return "Continue Assim!";
      if (valor >= 22) return "Quase lá";
      if (valor >= 18) return "Precisamos Melhorar";
      return "Atenção necessária";
    },

    getMensagemMargem() {
      const valor = this.dashboard.margemac || 0;
      if (valor >= 24) return "Continue Assim!";
      if (valor >= 22) return "Quase lá";
      if (valor >= 18) return "Precisamos Melhorar";
      return "Atenção necessária";
    },

    getMensagemAtingimento() {
      const valor = this.dashboard.peratingimentoac;
      if (valor >= 100) return "Meta Superada!";
      if (valor >= 90) return "Quase Lá!";
      if (valor >= 75) return "No Caminho";
      if (valor >= 60) return "Acelerando";
      return "Foco Total";
    },

    getMensagemProjecao() {
      const valor = this.dashboard.perprojecao;
      if (valor >= 100) return "Tendência Excelente";
      if (valor >= 95) return "Quase lá, falta pouco!";
      if (valor >= 90) return "Você está no Caminho!";
      return "Precisamos Vender Mais!";
    },

    getProjecaoStars() {
      return this.dashboard.perprojecao / 20;
    },

    // getMensagemBonificacao() {
    //   const valor = this.dashboard.bonificacao;
    //   const valor2 = this.dashboard.perbonificacao;
    //
    //   if (valor >= 1000) return "Você atingiu a bonificação máxima!";
    //   if (valor >= 500) return "Ótimo! Você desbloqueou uma bonificação!";
    //   if (valor2 > 91) return "Tá quase lá! Mantenha o foco!";
    //   if (valor2 > 80) return "Siga firme! Você está no caminho!";
    //   if (valor2 > 20) return "Continue evoluindo! Cada esforço conta!";
    //   return "Vamos ajustar o ritmo e reagir! ️";
    // },

    getMensagemBonificacao() {
      const valor = this.dashboard.bonificacao;
      const valor2 = this.dashboard.perbonificacao;

      if (valor >= 1000) return "Continue assim, para ganhar a bonificação de R$1.000,00";
      if (valor >= 500) return "Continue assim, para ganhar a bonificação de R$500,00";
      if (valor2 > 91) return "Tá quase lá! Mantenha o foco!";
      if (valor2 > 80) return "Siga firme! Você está no caminho!";
      if (valor2 > 20) return "Continue evoluindo! Cada esforço conta!";
      return "Vamos ajustar o ritmo e reagir! ️";
    },

    getDataAtual() {
      const hoje = new Date();

      const ano = hoje.getFullYear();
      const mes = String(hoje.getMonth() + 1).padStart(2, '0');
      const dia = String(hoje.getDate()).padStart(2, '0');

      return `${ano}-${mes}-${dia}`;
    },

    dataCampanha(hoje) {

      // datas definidas para campanha Queima de Estoque (Dinheiro e PIX) idpromocao = 7829
      let dataInicio = '2025-10-02'
      let dataFim = '2025-11-30'

      return hoje >= dataInicio && hoje <= dataFim
    },

    isPrimeiroMesCampanhaEbook(hoje) {
      // campanha de bonificação e-book iniciada em julho/2026 (IDPRODUTO 248545)
      return hoje >= '2026-07-01' && hoje <= '2026-07-31'
    },

    isPosicaoEbookAtual(pos) {
      return !!this.ebookRanking && this.ebookRanking.posicao === pos;
    },

    async getEbookRankingData() {
      this.carregandoEbook = true;
      try {
        // idvendedor só é respeitado pelo backend se quem chamou tiver a permissão master de filtro
        // (dashboard_vendedor_filtro_master) — pra todo mundo, o backend ignora e usa sempre o próprio
        // vendedor logado, mesmo enviando esse campo
        const response = await axios.post(`${this.backendUrl}bonificacao/ebook/vendedor/listar`, { idvendedor: this.idvendedor });
        this.ebookRanking = (response.data && response.data.length > 0) ? response.data[0] : null;
      } catch (error) {
        console.error('Erro ao carregar ranking da campanha e-book:', error);
      } finally {
        this.carregandoEbook = false;
      }
    },

    isClassificacaoAtualCampanhaVendaMargem(classificacao) {
      return !!this.campanhaVendaMargemVendedorAcumulado && this.campanhaVendaMargemVendedorAcumulado.classificacao === classificacao;
    },

    // cartaz de lançamento da campanha (arte do marketing) — abre uma vez só, na primeira vez que o
    // vendedor carrega a dashboard, e nunca mais (guardado no localStorage, por navegador/dispositivo).
    // Se algum dia precisar mostrar de novo pra todo mundo (ex: arte nova), é só trocar o valor de
    // CAMPANHA_VENDAS_CARTAZ_VISTO_KEY lá no topo do arquivo.
    abrirCartazCampanhaVendasSeNaoVisto() {
      try {
        if (localStorage.getItem(CAMPANHA_VENDAS_CARTAZ_VISTO_KEY)) return;
      } catch (e) {
        return; // localStorage bloqueado (aba anônima etc) — não força o cartaz nesse caso
      }
      this.dialogCampanhaVendasCartaz = true;
    },

    // navegação manual do carrossel "Dicas para ganhar mais pontos" — setas próprias no cabeçalho do
    // slide, em vez das setas padrão do v-carousel (ficavam flutuando por cima do texto)
    campanhaVendaMargemProximaDica() {
      const total = this.dicasCampanhaVendaMargem.length;
      this.campanhaVendaMargemDicaAtual = (this.campanhaVendaMargemDicaAtual + 1) % total;
    },
    campanhaVendaMargemDicaAnterior() {
      const total = this.dicasCampanhaVendaMargem.length;
      this.campanhaVendaMargemDicaAtual = (this.campanhaVendaMargemDicaAtual - 1 + total) % total;
    },

    // formata um "quanto falta" com 1 casa decimal — só sobe pra 2 casas quando 1 casa arredondaria um
    // valor real (> 0) pra "0.0", o que faz parecer que não falta nada quando na verdade falta um
    // pouquinho (ex: 0.05 vira "0.0" com 1 casa, mas "0.05" com 2)
    formatarFaltaComCasasDecimais(valor) {
      if (valor <= 0) return '0';
      const umaCasa = valor.toFixed(1);
      return umaCasa === '0.0' ? valor.toFixed(2) : umaCasa;
    },

    // texto "quanto falta" pros Blocos E/F (metas pessoais) — recebe a diferença já não-negativa de
    // atingimento e de margem até o limiar exigido, dizendo explicitamente qual dos dois critérios (ou os
    // dois) foi o motivo de não ganhar os cupons daquela regra. Pro mês corrente é no presente/futuro
    // ("Faltam", ainda dá tempo); pra um mês já passado (mostrado só quando chegou perto, ver
    // campanhaVendaMargemLinhaBlocoPessoal) é no passado ("Faltou"), reforçando que foi por pouco
    campanhaVendaMargemTextoFalta(fa, fm, mesPassado, pontos, acumulado = false) {
      const alvo = pontos ? ` para os ${pontos} cupons` : '';
      const rotuloAtingimento = acumulado ? 'de atingimento acumulado' : 'de atingimento';
      const partes = [];
      if (fa > 0) partes.push(`${this.formatarFaltaComCasasDecimais(fa)}% ${rotuloAtingimento}`);
      if (fm > 0) partes.push(`${this.formatarFaltaComCasasDecimais(fm)}pp de margem`);

      if (!partes.length) return mesPassado ? `Quase lá${alvo}!` : 'Quase lá!';

      const faltouTexto = partes.join(' e ');
      return mesPassado
          ? `Quase lá! Faltou ${faltouTexto}${alvo}.`
          : `Faltam ${faltouTexto}${alvo}.`;
    },

    // monta os "pontos por regra" de UM período específico (`item` = uma entrada de
    // campanhaVendaMargemVendedorAcumulado ou de campanhaVendaMargemVendedorMeses) — chamada uma vez por
    // período dentro de campanhaVendaMargemHistorico, um painel por período.
    //
    // Regra 1 é a base (sempre aparece). Blocos A-D dependem de vencer uma disputa (maior venda da
    // rede/filial, top 10 e-book, top 10 sem giro) — pra não virar uma parede de zeros desanimadora pra
    // quem não ganhou nenhum, só aparecem quando o vendedor de fato ganhou algum cupom ali (não dá pra
    // mostrar "quanto falta" sem expor o desempenho de outros vendedores). Já os Blocos E e F são metas
    // pessoais (não dependem de ninguém): no mês corrente sempre aparecem (ainda dá tempo de correr atrás),
    // mas num mês JÁ PASSADO só aparecem zerados se chegou perto (dentro do limite de
    // campanhaVendaMargemLinhaBlocoPessoal) — bem perto, vale mostrar "quase lá" como incentivo pro próximo
    // mês; longe, é melhor nem lembrar de um mês que já fechou e não tem mais volta.
    campanhaVendaMargemPontosPorRegraDe(item) {
      if (!item) return [];

      // uma entrada de mês sempre tem `.mes` (formato "aaaa-mm"); a entrada do Total Geral nunca tem
      const ehMes = !!item.mes;
      const mesAtual = new Date().toISOString().slice(0, 7);
      const mesPassado = ehMes && item.mes < mesAtual;
      const ehMesAtual = ehMes && item.mes === mesAtual;

      // a dica de "quanto falta"/aviso de margem da Regra 1 só aparece no mês corrente (só ele ainda pode
      // render cupons novos) ou num mês JÁ PASSADO específico (histórico, congelado) — no Total Geral não
      // mostra nada: pedido explícito de não misturar dica de "mês corrente" dentro do card acumulado
      const resumoMesAtual = this.campanhaVendaMargemVendedorMeses.find((mes) => mes.mes === mesAtual);
      const fonteRegra1 = mesPassado ? item : (resumoMesAtual || item);

      const linhas = [
        this.campanhaVendaMargemLinhaRegra1(item, fonteRegra1, mesPassado, ehMesAtual),
      ];

      const blocosCompetitivos = [
        { chave: 'cupons_bloco_a', label: 'Bloco A', sublabel: 'Quem mais vendeu na rede', icone: 'mdi-crown-outline' },
        { chave: 'cupons_bloco_b', label: 'Bloco B', sublabel: 'Quem mais vendeu na filial', icone: 'mdi-store-outline' },
        { chave: 'cupons_bloco_c', label: 'Bloco C', sublabel: 'Top 10 Educa e-book', icone: 'mdi-book-open-page-variant-outline' },
        { chave: 'cupons_bloco_d', label: 'Bloco D', sublabel: 'Produto sem giro', icone: 'mdi-archive-outline' },
      ];
      blocosCompetitivos.forEach((bloco) => {
        const qtd = item[bloco.chave] || 0;
        if (qtd === 0) return;
        const linha = { label: bloco.label, sublabel: bloco.sublabel, icone: bloco.icone, qtd };
        // blocos competitivos (A-D) são recalculados até o mês fechar — quem está na frente agora pode ser
        // ultrapassado por outro vendedor antes do fim do mês, diferente de um mês já passado (congelado,
        // não tem mais como perder) ou do Total Geral (não é "a posição de agora", é o resultado somado)
        if (ehMesAtual) {
          linha.aviso = 'Mantenha o ritmo pra não cair dessa posição até o fim do mês.';
        }
        linhas.push(linha);
      });

      const linhaE = this.campanhaVendaMargemLinhaBlocoPessoal({
        label: 'Bloco E', sublabel: 'Margem + atingimento', icone: 'mdi-target',
        qtd: item.cupons_bloco_e || 0,
        pontos: 5,
        faltaAtingimento: ehMes && typeof item.margem_minima === 'number' ? 85 - item.peratingimento : null,
        faltaMargem: ehMes && typeof item.margem_minima === 'number' ? item.margem_minima - item.margem : null,
        mesPassado,
        ehMesAtual,
        margemMinima: item.margem_minima,
        periodo: 'mês',
      });
      if (linhaE) linhas.push(linhaE);

      const mesNum = item.mes ? Number(item.mes.split('-')[1]) : null;
      const fechaTrimestre = ehMes && (mesNum === 9 || mesNum === 12);
      if (fechaTrimestre || item.cupons_bloco_f > 0) {
        const temTrimestre = fechaTrimestre && typeof item.peratingimento_trimestre === 'number' && typeof item.margem_trimestre === 'number';
        const linhaF = this.campanhaVendaMargemLinhaBlocoPessoal({
          label: 'Bloco F', sublabel: 'Meta acumulada do trimestre', icone: 'mdi-calendar-star',
          qtd: item.cupons_bloco_f || 0,
          pontos: 20,
          faltaAtingimento: temTrimestre ? 100 - item.peratingimento_trimestre : null,
          faltaMargem: temTrimestre ? item.margem_minima - item.margem_trimestre : null,
          mesPassado,
          acumulado: true,
          ehMesAtual,
          margemMinima: item.margem_minima,
          periodo: 'trimestre',
        });
        if (linhaF) linhas.push(linhaF);
      }

      // mesmo texto do dialog "Como funciona a campanha" (REGRA1_EXPLICACAO/BLOCOS_EXPLICACAO), reaproveitado
      // aqui pra alimentar o tooltip de cada mini-card — assim o vendedor entende a regra sem precisar abrir
      // o dialog e procurar o bloco certo
      linhas.forEach((linha) => {
        linha.explicacao = this.explicacaoRegraCampanhaVendaMargem(linha.label);
      });

      // no Total Geral, um card zerado não tem "quanto falta" pra mostrar (é só um resultado já somado,
      // parado em 0) — esconde qualquer linha com qtd 0 nesse período específico. Nos meses (corrente ou
      // já passado) os zerados continuam aparecendo normalmente, porque ali fazem sentido (mostram "quanto
      // falta" ou "quase lá")
      if (!ehMes) {
        return linhas.filter((linha) => linha.qtd > 0);
      }

      return linhas;
    },

    // busca o mesmo texto do dialog "Como funciona a campanha" pra Regra 1 ou um Bloco específico, pelo
    // label exibido no mini-card ("Regra 1", "Bloco A", "Bloco B"...)
    explicacaoRegraCampanhaVendaMargem(label) {
      if (label === 'Regra 1') return REGRA1_EXPLICACAO_CAMPANHA_VENDA_MARGEM.texto;
      const bloco = BLOCOS_EXPLICACAO_CAMPANHA_VENDA_MARGEM.find((b) => b.bloco === label);
      return bloco ? bloco.texto : '';
    },

    // monta a linha de um bloco "meta pessoal" (E ou F): se já ganhou, mostra o cupom (com aviso de manter
    // a margem, se for o mês corrente — mesma lógica do aviso da Regra 1 e dos blocos competitivos: a
    // margem do mês/trimestre só fecha de vez quando o período termina, então ainda dá pra cair abaixo do
    // mínimo e perder o cupom); se não ganhou mas dá pra calcular o quanto falta (mês selecionado, com
    // dados suficientes), mostra "quanto falta" — só que, se for um mês JÁ PASSADO e a distância for
    // grande (longe do limite abaixo), retorna null (esconde a linha por completo, ver justificativa no
    // comentário de campanhaVendaMargemPontosPorRegraDe)
    campanhaVendaMargemLinhaBlocoPessoal({ label, sublabel, icone, qtd, pontos, faltaAtingimento, faltaMargem, mesPassado, acumulado = false, ehMesAtual = false, margemMinima = null, periodo = 'mês' }) {
      if (qtd > 0) {
        const linha = { label, sublabel, icone, qtd };
        if (ehMesAtual && typeof margemMinima === 'number') {
          linha.aviso = `Mantenha a margem acima de ${margemMinima.toFixed(0)}% para não perder os ${pontos} cupons deste ${periodo}.`;
        }
        return linha;
      }
      if (faltaAtingimento === null || faltaMargem === null) return { label, sublabel, icone, qtd: 0 };

      const LIMITE_FALTA_ATINGIMENTO = 5; // pontos percentuais de atingimento da meta
      const LIMITE_FALTA_MARGEM = 2; // pontos percentuais de margem
      const fa = Math.max(0, faltaAtingimento);
      const fm = Math.max(0, faltaMargem);
      const chegouPerto = fa <= LIMITE_FALTA_ATINGIMENTO && fm <= LIMITE_FALTA_MARGEM;

      if (mesPassado && !chegouPerto) return null;

      return { label, sublabel, icone, qtd: 0, falta: this.campanhaVendaMargemTextoFalta(fa, fm, mesPassado, pontos, acumulado) };
    },

    // linha da Regra 1 (classificação) — diferente dos Blocos E/F, ela sempre aparece (é a base, não um
    // bônus) e sempre tem "próximo nível" até chegar em OURO, então a dica de "quanto falta" não depende de
    // qtd === 0: mesmo já tendo cupom, sempre dá pra subir de faixa. A mensagem fala em cupons concretos
    // ("faltam X% para +N cupons"), não no nome da classificação — mais direto pro vendedor entender o que
    // está em jogo.
    //
    // `item` é o período sendo exibido (define o número grande do card); `fonte` é de onde vêm a dica de
    // crescimento e o aviso de manutenção. Total Geral (nem mesPassado nem ehMesAtual) não mostra nenhuma
    // dica — só o mês corrente (ehMesAtual) ou um mês JÁ PASSADO específico (histórico, congelado, só se
    // chegou perto) — e mesmo aí, aviso de manutenção de margem é exclusivo do mês corrente (não há mais
    // nada a manter num mês que já fechou, nem faz sentido repetir isso no Total Geral).
    campanhaVendaMargemLinhaRegra1(item, fonte, mesPassado, ehMesAtual) {
      const linha = { label: 'Regra 1', sublabel: 'Classificação', icone: 'mdi-medal-outline', qtd: item.cupons_regra1 || 0 };
      if (!mesPassado && !ehMesAtual) return linha;

      if (
          fonte.proxima_classificacao
          && typeof fonte.perc_falta_proxima_classificacao === 'number'
          && typeof fonte.ganho_cupons_proxima_classificacao === 'number'
      ) {
        const LIMITE_FALTA_ATINGIMENTO = 5; // pontos percentuais de atingimento da meta
        const falta = Math.max(0, fonte.perc_falta_proxima_classificacao);
        const ganho = fonte.ganho_cupons_proxima_classificacao;

        if (!mesPassado || falta <= LIMITE_FALTA_ATINGIMENTO) {
          if (falta <= 0 || ganho <= 0) {
            linha.falta = 'Quase lá!';
          } else {
            const prefixo = mesPassado ? 'Quase lá! Faltou' : 'Faltam';
            linha.falta = `${prefixo} ${this.formatarFaltaComCasasDecimais(falta)}% de atingimento para +${ganho} cupons.`;
          }
        }
      }

      if (ehMesAtual && fonte.cupons_regra1 > 0 && typeof fonte.margem_piso_atual === 'number') {
        linha.aviso = `Mantenha a margem acima de ${fonte.margem_piso_atual.toFixed(0)}% para não perder os ${fonte.cupons_regra1} cupons deste mês.`;
      }

      return linha;
    },

    async getCampanhaVendaMargemVendedorData() {
      this.carregandoCampanhaVendaMargemVendedor = true;
      try {
        // idvendedor: mesma regra de getEbookRankingData — só é respeitado com a permissão master
        const [acumuladoRes, mesesRes] = await Promise.all([
          axios.post(`${this.backendUrl}bonificacao/campanha-venda-margem/vendedor/acumulado/listar`, { idvendedor: this.idvendedor }),
          axios.post(`${this.backendUrl}bonificacao/campanha-venda-margem/vendedor/meses/listar`, { idvendedor: this.idvendedor }),
        ]);
        this.campanhaVendaMargemVendedorAcumulado = (acumuladoRes.data && acumuladoRes.data.length > 0) ? acumuladoRes.data[0] : null;
        this.campanhaVendaMargemVendedorMeses = mesesRes.data || [];
      } catch (error) {
        console.error('Erro ao carregar campanha de venda e margem do vendedor:', error);
      } finally {
        this.carregandoCampanhaVendaMargemVendedor = false;
      }
    },

    listaBonificacoesCampanha() {

      this.carregando = true;
      this.rankingCampanha.listaVendedores = [];
      return axios
          .post(`${this.backendUrl}bonificacao/campanha/listar`, {
            data: this.getDataAtual(),
            idempresa: this.usuario.idfilial.toString(),
            idvendedor: 1
          })
          .then((res) => {
            let dados = res.data;
            this.rankingCampanha.listaVendedores = dados.listavendedores;
            this.vendaCampanha = this.rankingCampanha.listaVendedores.find(v => v.idempresa === this.usuario.idfilial)?.vendabonificacao || 0
            this.bonificacaoCampanha = this.rankingCampanha.listaVendedores.find(v => v.idempresa === this.usuario.idfilial)?.comissao || 0

            // console.log('venda: ', this.vendaCampanha)
            // console.log('comissao: ', this.bonificacaoCampanha)
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },

    async getDashboardData() {
      // console.log('hoje: ', this.getDataAtual())
      // console.log('condicao: ', this.dataCampanha(this.getDataAtual()))
      this.carregando = true;

      // Reset dashboard
      this.dashboard = {
        peratingimentoac: 0,
        perprojecao: 0,
        bonificacao: 0,
        perbonificacao: 0,
        mensagem: null,
        margemac: 0,
        vendedor: '',
        peratingimentoad: 0,
        peratingimentoad_new: 0,
        margemad: 0,
      };

      try {
        // idvendedor: mesma regra de getEbookRankingData — só é respeitado com a permissão master
        const response = await axios.post(`${this.backendUrl}bonificacao/vendedor/listar`, {
          idvendedor: this.idvendedor
        });

        if (response.data && response.data.length > 0) {
          const MARGEM_MAX = 24;
          const ATING_MAX = 110;
          this.dashboard = response.data[0];

          let margem = Math.min(this.dashboard.margemac, MARGEM_MAX);
          // let atingimento = Math.min(this.dashboard.peratingimentoac, ATING_MAX);
          let atingimento = Math.min(this.dashboard.perprojecao, ATING_MAX);

          // this.dashboard.perbonificacao = ((margem / MARGEM_MAX) + (atingimento / ATING_MAX)) / 2 * 100;
          this.dashboard.perbonificacao = Math.floor(((margem / MARGEM_MAX) + (atingimento / ATING_MAX)) / 2 * 100);
          // console.log(this.dashboard.perbonificacao)
        }
      } catch (error) {
        console.error('Erro ao carregar dados do dashboard:', error);
        this.$toast.error('Erro ao carregar dados do dashboard');
      } finally {
        this.carregando = false;
      }
    },

    async carregarVendedores(busca) {
      if (!busca || busca.length < 2) {
        this.vendedores = [];
        return;
      }

      // Limpar timeout anterior
      if (this.aguardarBusca) {
        clearTimeout(this.aguardarBusca);
      }

      this.aguardarBusca = setTimeout(async () => {
        this.carregandoVendedores = true;

        try {
          const response = await axios.post(`${this.backendUrl}cliente/listar`, {
            tipo: "V",
            limit: 20,
            offset: 0,
            busca: busca
          });

          this.vendedores = response.data.lista || [];

          // Se encontrou apenas um vendedor, seleciona automaticamente
          if (response.data.total === 1 && this.vendedores.length === 1) {
            this.idvendedor = this.vendedores[0].idcliente;
          }
        } catch (error) {
          console.error('Erro ao buscar vendedores:', error);
          this.vendedores = [];
        } finally {
          this.carregandoVendedores = false;
        }
      }, 300);
    }
  },

  watch: {
    search(novoValor) {
      this.carregarVendedores(novoValor);
    },

    // troca (ou limpa) o vendedor selecionado no filtro master — recarrega as 3 fontes de dados da
    // dashboard do vendedor (Métricas, Campanha E-book, Campanha de Vendas), não só a principal, senão as
    // outras duas ficariam mostrando o vendedor anterior. Limpar o filtro (novoId null) também recarrega:
    // o backend cai de volta pro vendedor da própria sessão quando idvendedor não vem preenchido
    idvendedor() {
      this.getDashboardData();
      if (this.podeVerCampanhaEbookVendedor) {
        this.getEbookRankingData();
      }
      if (this.podeVerCampanhaVendaMargemVendedor) {
        this.getCampanhaVendaMargemVendedorData();
      }
    },

    // só grava no localStorage (pra nunca mais abrir sozinho) se o vendedor marcou a flag "Não exibir
    // novamente" antes de fechar — funciona independente de como fechou (botão, clique fora, ESC). Se
    // fechar sem marcar a flag, não grava nada, e o cartaz volta a abrir na próxima vez que a página carregar
    dialogCampanhaVendasCartaz(aberto) {
      if (aberto || !this.campanhaVendasCartazNaoExibirNovamente) return;
      try {
        localStorage.setItem(CAMPANHA_VENDAS_CARTAZ_VISTO_KEY, '1');
      } catch (e) {
        // localStorage bloqueado — sem problema, só significa que pode abrir de novo na próxima visita
      }
    },
  },

  beforeDestroy() {
    if (this.aguardarBusca) {
      clearTimeout(this.aguardarBusca);
    }
  },

  created() {
    // aba padrão é "Campanha de Vendas", mas nem todo vendedor tem essa permissão — cai pra E-book, e por
    // último pra Métricas (essa sempre existe), senão a navegação abriria numa aba vazia/escondida
    if (!this.podeVerCampanhaVendaMargemVendedor) {
      this.abaVendedorAtiva = this.podeVerCampanhaEbookVendedor ? 'campanha-ebook' : 'metricas-vendas';
    }

    this.getDashboardData();
    this.listaBonificacoesCampanha();
    if (this.podeVerCampanhaEbookVendedor) {
      this.getEbookRankingData();
    }
    if (this.podeVerCampanhaVendaMargemVendedor) {
      this.getCampanhaVendaMargemVendedorData();
      this.abrirCartazCampanhaVendasSeNaoVisto();
    }
  }
};
</script>

<style scoped>
/* tabs de navegação do vendedor (Campanha de Vendas / Campanha E-book / Métricas) — levemente arredondadas
   em vez do estilo padrão do Vuetify (retangular, com sublinhado reto); trocado o sublinhado por um fundo
   navy clarinho na aba ativa, mais parecido com um segmented control */
::v-deep .campanha-vm-tabs-vendedor .v-tabs-bar {
  background: transparent !important;
}
/* quando as abas transbordam num celular, o Vuetify reserva ~52px de espaço invisível pro botão de "voltar"
   mesmo sem show-arrows (visibility: hidden, mas ocupando o layout) — sem isso, sobrava um vão em branco
   à esquerda da primeira aba */
::v-deep .campanha-vm-tabs-vendedor .v-slide-group__prev,
::v-deep .campanha-vm-tabs-vendedor .v-slide-group__next {
  display: none !important;
}
::v-deep .campanha-vm-tabs-vendedor .v-tab {
  border-radius: 10px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: normal;
  margin-right: 6px;
  color: #64748b !important;
  transition: all 0.2s ease;
}
::v-deep .campanha-vm-tabs-vendedor .v-tab--active {
  background: rgba(2, 52, 73, 0.08);
  color: #023449 !important;
}
/* num celular estreito o texto das 3 abas não cabe de uma vez — encolhe a fonte/o espaçamento pra liberar
   espaço; sem setas de navegação (tiradas de propósito, ocupavam espaço à toa), a rolagem é por toque
   (swipe), como o v-tabs já suporta nativamente */
@media (max-width: 600px) {
  ::v-deep .campanha-vm-tabs-vendedor .v-tab {
    font-size: 12px;
    padding: 0 10px;
  }
}

/* botão de fechar do cartaz de lançamento — flutua sobre a arte, num círculo escuro translúcido pra ficar
   legível em cima de qualquer cor da imagem */
.campanha-vm-cartaz-fechar {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.45) !important;
}

/* Card da Campanha de Vendas (vendedor) — segue o mesmo estilo visual do PainelFiltros.vue: cartão branco
   com borda/sombra sutil (em vez de elevation do Vuetify), ícone de destaque em wrapper com gradiente navy,
   e seções internas em "caixa" com gradiente claro + borda fina, no lugar de blocos cinza chapado. */
.campanha-vm-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}
.campanha-vm-card:hover {
  box-shadow: 0 4px 12px rgba(2, 52, 73, 0.12);
  border-color: #cbd5e1;
}
.campanha-vm-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  box-shadow: 0 2px 6px rgba(2, 52, 73, 0.08);
}
.campanha-vm-icon-wrapper--active {
  background: linear-gradient(135deg, #023449 0%, #0369a1 100%);
  box-shadow: 0 4px 10px rgba(2, 52, 73, 0.2);
}
/* campo de busca do filtro de vendedor — mesmo visual do campo do SeletorCliente.vue (fundo cinza claro,
   borda de 2px que vira navy com anel suave no foco), em vez do "rounded" padrão do Vuetify, que em cima de
   outlined deixava a borda arredondada demais (efeito "derretido") */
::v-deep .campanha-vm-filtro-vendedor-input .v-input__control {
  min-height: 44px !important;
}
::v-deep .campanha-vm-filtro-vendedor-input fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
  border-radius: 10px;
  transition: all 0.2s ease;
}
::v-deep .campanha-vm-filtro-vendedor-input .v-input__slot {
  background: #f8fafc;
  transition: all 0.2s ease;
  border-radius: 10px;
}
::v-deep .campanha-vm-filtro-vendedor-input .v-input__slot:hover fieldset {
  border-color: #023449;
}
::v-deep .campanha-vm-filtro-vendedor-input.v-input--is-focused fieldset {
  border-color: #023449 !important;
  border-width: 2px;
  box-shadow: 0 0 0 3px rgba(2, 52, 73, 0.1);
}
::v-deep .campanha-vm-filtro-vendedor-input.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}
.campanha-vm-titulo {
  font-size: 15px;
  font-weight: 700;
  color: #023449;
  letter-spacing: -0.01em;
}
.campanha-vm-box-titulo {
  font-size: 13px;
  font-weight: 700;
  color: #023449;
  letter-spacing: -0.01em;
}
/* legenda discreta acima de cada "linha do tempo" de faixas (CampanhaVendaMargemFaixas) — funciona como
   título de gráfico, não como mensagem: maiúscula, pequena, cor neutra, sem ícone. Ordem do bloco é mensagem
   motivacional → legenda → barra, por isso a margem no topo (separa da mensagem acima) */
.campanha-vm-faixa-legenda {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 10px;
  margin-bottom: 4px;
}
/* botão "Como funciona a campanha" — antes era só um ícone cinza discreto no cabeçalho do card, fácil de
   nem perceber que era clicável; agora é uma pílula com texto + ícone, fundo azul clarinho, pra chamar
   mais atenção como algo interativo */
::v-deep .campanha-vm-btn-como-funciona {
  text-transform: none;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: normal;
  background: rgba(3, 105, 161, 0.08) !important;
  border-radius: 20px;
  padding: 0 12px !important;
  height: 28px !important;
}
::v-deep .campanha-vm-btn-como-funciona:hover {
  background: rgba(3, 105, 161, 0.16) !important;
}
.campanha-vm-box {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  transition: all 0.2s ease;
}
.campanha-vm-premio {
  border-width: 1.5px !important;
}
.campanha-vm-premio--atual {
  border: 1.5px solid #023449 !important;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.12);
}
.campanha-vm-premio-conteudo {
  height: 100%;
}
/* o -12px de margin embutido do v-row (compensa o gutter interno dos v-col) comia boa parte do espaçamento
   do título seguinte ("Dicas para ganhar mais pontos"), deixando os dois praticamente colados */
.campanha-vm-premios-lista {
  margin-bottom: 20px;
}
/* tag "Atualmente você está aqui" — em todos os tamanhos de tela agora (antes só aparecia no mobile; o
   card com a borda navy já destacava a classificação atual no desktop, mas o texto deixa isso explícito
   também lá) */
.campanha-vm-premio-atual-tag {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  color: #023449;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #cbd5e1;
}
/* marcador da linha do tempo (bolinha + linha) — escondido por padrão; ganha layout vertical no mobile
   (marcador ao lado do card) e horizontal no desktop/tablet (marcador em cima do card), nos dois casos
   formando a leitura de "escada de progresso" entre BRONZE → PRATA → OURO */
.campanha-vm-premio-marcador {
  display: none;
}
.campanha-vm-premio-dot {
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff;
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}
/* cor de fundo/anel da bolinha atual vem inline (:style), na cor da classificação (OURO/PRATA/BRONZE) */
.campanha-vm-premio-dot--atual {
  width: 16px;
  height: 16px;
}
.campanha-vm-premio-linha {
  background: #e2e8f0;
  flex: 1 1 auto;
}
/* sem linha depois do último card (OURO é o topo, não tem pra onde continuar) — visibility em vez de
   display:none, pra manter o espaço e a bolinha continuar centralizada/alinhada. Já ANTES do primeiro
   (BRONZE) a linha fica visível de propósito, como se a escada continuasse pra fora da tela — sugerindo
   que existe uma faixa anterior (NÃO ATINGIU) sem precisar escrever isso */
.campanha-vm-premios-lista .campanha-vm-premio-item:last-child .campanha-vm-premio-linha-baixo {
  visibility: hidden;
}
@media (max-width: 600px) {
  .campanha-vm-premio-item {
    display: flex;
    gap: 10px;
  }
  .campanha-vm-premio-marcador {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 16px;
    flex-shrink: 0;
  }
  /* linha de cima e de baixo do mesmo tamanho (flex:1 cada) — a bolinha fica sempre no meio da altura do
     card, não colada no topo */
  .campanha-vm-premio-linha {
    width: 2px;
  }
  .campanha-vm-premio-linha-topo {
    margin-bottom: 4px;
  }
  .campanha-vm-premio-linha-baixo {
    margin-top: 4px;
  }
  .campanha-vm-premio-conteudo {
    height: auto;
    flex: 1 1 auto;
  }
}
@media (min-width: 601px) {
  /* no desktop os cards ficam mais altos (3 itens de prêmio + eventualmente a tag "atualmente você está
     aqui"), então os 20px base ainda deixavam pouco respiro até "Dicas para ganhar mais pontos" */
  .campanha-vm-premios-lista {
    margin-bottom: 32px;
  }
  /* no desktop/tablet o marcador fica deitado, em cima do card (a ordem no DOM já é marcador → card, então
     sem precisar de flex no item, eles já empilham verticalmente sozinhos) — cada card carrega seu pedaço
     da linha horizontal, que "conecta" visualmente com o pedaço do card vizinho */
  .campanha-vm-premio-marcador {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    /* altura fixa (do tamanho da bolinha atual, a maior) — sem isso, a linha do card OURO (bolinha de
       16px) ficava centralizada numa caixa mais alta que a dos outros 2 (bolinha de 12px), descendo a
       linha (e o card logo abaixo dela) alguns pixels em relação aos demais */
    height: 16px;
    margin-bottom: 10px;
  }
  .campanha-vm-premio-linha {
    height: 2px;
  }
  .campanha-vm-premio-linha-topo {
    margin-right: 4px;
  }
  .campanha-vm-premio-linha-baixo {
    margin-left: 4px;
  }
  /* "Atualmente você está aqui" vira rodapé: empurrado pro fim do card com margin-top:auto, em vez de ficar
     largado logo após os itens com espaço em branco sobrando embaixo (os 3 cards têm a mesma altura, mas
     quantidades diferentes de prêmio) */
  .campanha-vm-premio-conteudo {
    display: flex;
    flex-direction: column;
  }
  .campanha-vm-premio-atual-tag {
    margin-top: auto;
  }
}
/* cabeçalho e boxes do dialog "Como funciona a campanha" — mesma linguagem visual do resto do card
   (gradiente navy no título, box cinza clarinho pra Regra 1, ícones em "selo" navy reaproveitados do
   carrossel de dicas via .campanha-vm-dica-icone) */
.campanha-vm-regras-titulo {
  background: linear-gradient(135deg, #023449 0%, #0369a1 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}
.campanha-vm-regras-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
}
.campanha-vm-regras-box + .campanha-vm-regras-box {
  margin-top: 12px;
}
.campanha-vm-bloco-linha {
  padding-top: 10px;
}
.campanha-vm-bloco-linha + .campanha-vm-bloco-linha {
  border-top: 1px dashed #e2e8f0;
}
/* tabela de cupons da Regra 1 no dialog "Como funciona a campanha" — um grupo por classificação, com uma
   linha por faixa de margem */
.campanha-vm-regra1-grupo {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
}
.campanha-vm-regra1-linha {
  padding: 2px 0;
}
.campanha-vm-regra1-linha + .campanha-vm-regra1-linha {
  border-top: 1px dashed #e2e8f0;
}
/* faixa da classificação atual dentro do HERO — mesma pegada visual das outras caixas do card, só que com
   uma faixa colorida na esquerda (cor da classificação atual) pra chamar mais atenção */
.campanha-vm-tag-premio {
  border-left: 4px solid;
  border-radius: 8px;
}
/* grid dos mini-cards de "Pontos por regra" — flexbox em vez de v-row/v-col de colunas fixas, porque a
   quantidade de cards varia (6 ou 7, conforme o Bloco F entra ou não) e a largura do card também varia
   conforme o menu lateral/tamanho de tela; com flex-basis os cards crescem pra preencher a linha e cabem
   todos numa linha só em telas largas (notebook+), sem precisar de breakpoint fixo por quantidade */
.campanha-vm-regra-grid {
  gap: 8px;
}
.campanha-vm-regra-card-wrap {
  flex: 1 1 130px;
  min-width: 130px;
}
/* só limita a largura quando sobram poucos cards na linha (1 ou 2, ex: só "Regra 1" ganhou naquele mês) —
   sem isso o flex-grow estica o(s) card(s) pra ocupar a linha inteira, um vazio enorme ao lado do
   conteúdo. Com mais cards (4+) essa mesma trava sobrava espaço em branco no fim da linha, então ela some
   e cada card cresce livremente pra preencher a linha por igual entre eles */
.campanha-vm-regra-card-wrap--poucos {
  max-width: 200px;
}
/* no celular, com tanto texto por card agora (falta, aviso de margem, aviso de posição...), 2 por linha
   ficava espremido e cortando mal — 1 card por linha (largura cheia) lê muito melhor num telão estreito */
@media (max-width: 600px) {
  .campanha-vm-regra-card-wrap,
  .campanha-vm-regra-card-wrap--poucos {
    min-width: 100%;
    max-width: 100%;
  }
}
/* mini-cards de "Pontos por regra" — fundo branco liso (a caixa que os envolve já tem o gradiente), pra não
   duplicar gradiente dentro de gradiente; destaca sutilmente quando o vendedor já tem cupom naquela regra.
   Altura padrão entre os cards da mesma linha (align-items: stretch, o default do flex) */
.campanha-vm-regra-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  height: 100%;
  transition: all 0.2s ease;
}
.campanha-vm-regra-card--positivo {
  border-color: #cbd5e1;
  box-shadow: 0 1px 4px rgba(2, 52, 73, 0.08);
}
/* Bloco E/F ainda não conquistados, mas com "quanto falta" calculável (metas pessoais) — âmbar em vez de
   cinza neutro, pra comunicar "quase lá" em vez de "zerado" */
.campanha-vm-regra-card--proximo {
  border-color: #fbbf24;
  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 100%);
}

/* "Pontos por regra" — lista de painéis expansíveis, um por período; tirado o elevation/borda padrão do
   Vuetify (flat) e recolorido pra combinar com o resto do card */
::v-deep .campanha-vm-historico.v-expansion-panels {
  border-radius: 0;
}
::v-deep .campanha-vm-historico .v-expansion-panel {
  background: transparent !important;
  border-bottom: 1px solid #e2e8f0;
}
::v-deep .campanha-vm-historico .v-expansion-panel::before {
  box-shadow: none !important;
}
::v-deep .campanha-vm-historico .v-expansion-panel:last-child {
  border-bottom: none;
}
::v-deep .campanha-vm-historico-header {
  padding: 10px 4px !important;
  min-height: 0 !important;
}
::v-deep .campanha-vm-historico .v-expansion-panel-content__wrap {
  padding: 0 4px 12px !important;
}
/* linha do Total Geral — destacada como uma linha de total de tabela (fundo tintado + divisória grossa em
   cima), separando visualmente do restante da lista de meses */
::v-deep .campanha-vm-historico .campanha-vm-historico-total {
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%) !important;
  border-top: 2px solid #023449;
  border-radius: 0 0 8px 8px;
}
::v-deep .campanha-vm-historico .campanha-vm-historico-total .campanha-vm-historico-header {
  padding-left: 8px !important;
}
/* spinner "Em andamento" — o padrão do Vuetify (1.4s por volta) gira rápido demais pra um indicador que só
   precisa comunicar "ainda em apuração", sem chamar tanta atenção; deixei mais lento e mais discreto */
::v-deep .campanha-vm-spinner-mes-atual svg {
  animation-duration: 2.6s !important;
}
::v-deep .campanha-vm-spinner-mes-atual .v-progress-circular__overlay {
  animation-duration: 2.6s !important;
}
/* colunas fixas de chip/cupons de cada linha de "Pontos por regra" — em telas largas alinham verticalmente
   entre os meses (ver comentário no template); num celular estreito (~360px) essa largura fixa não cabia
   ao lado do label e cortava o texto ("+ 10 cu..."), então no mobile a linha quebra em duas (label em
   cima, chip+cupons embaixo) em vez de forçar tudo numa linha só */
.campanha-vm-historico-chip-col {
  width: 118px;
}
.campanha-vm-historico-cupons-col {
  width: 155px;
}
/* chip encostado na direita da própria coluna, cupons encostado na esquerda da própria coluna — os dois se
   aproximam e formam um par bem agrupado no meio da linha, em vez de ficarem espalhados nas pontas com um
   vão vazio enorme entre eles (chip lá na esquerda, cupons lá na direita). O respiro sobra nas bordas de
   fora, não mais espremido no meio */
.campanha-vm-historico-variante {
  gap: 12px;
}
@media (max-width: 768px) {
  /* breakpoint mais largo que os outros blocos dessa tela (768px, não 600px): esse card não tem max-width
     próprio, então em telas médias (tablet, ou celular maior) ele ainda é largo o bastante pro breakpoint de
     600px não disparar, mas estreito o bastante pra "cupons até agora" não caber ao lado do chip com a
     largura fixa do desktop — o texto quebrava no meio da frase dentro da própria coluna, em vez de virar
     pra linha de baixo inteira. Grid de 2 colunas em vez de flex-wrap: garante DETERMINISTICAMENTE mês+chip
     na mesma linha de cima (chip encostado na direita) e cupons numa linha de baixo por conta própria
     (encostado na esquerda) — com flex-wrap isso dependia de sobrar espaço sozinho, e às vezes o chip
     acabava quebrando junto com os cupons em vez de ficar ao lado do título. "campanha-vm-historico-variante"
     (que no desktop agrupa chip+cupons visualmente colados) vira display:contents nesse breakpoint — some
     como caixa própria e deixa seus filhos (chip-col, cupons-col) virarem itens diretos do grid da linha */
  /* !important necessário: campanha-vm-historico-linha e campanha-vm-historico-variante também têm a
     classe utilitária "d-flex" do Vuetify, que aplica "display: flex !important" — sem vencer isso aqui,
     o "display: grid"/"display: contents" abaixo é simplesmente ignorado e a linha continua em flexbox */
  .campanha-vm-historico-linha {
    display: grid !important;
    grid-template-columns: 1fr auto;
    column-gap: 8px;
    row-gap: 2px;
  }
  .campanha-vm-historico-variante {
    display: contents !important;
  }
  .campanha-vm-historico-chip-col {
    width: auto;
    justify-self: end;
  }
  /* ocupa as 2 colunas do grid (linha inteira, força quebra pra baixo do título+chip) — não depende de
     calcular se cabe do lado, então nunca mais quebra no meio da frase ("Em andamento" + "X cupons até
     agora" não cabiam juntos e cortavam de um jeito estranho) */
  .campanha-vm-historico-cupons-col {
    width: auto;
    grid-column: 1 / -1;
    justify-self: start;
    justify-content: flex-start !important;
  }
}

/* carrossel "Dicas para ganhar mais pontos" — as setas/indicadores nativos do v-carousel são pensados pra
   foto de fundo e ficam flutuando por cima do texto num slide de conteúdo; por isso as setas de navegação
   e o contador "X/N" são feitos à mão no cabeçalho do próprio slide (:show-arrows="false",
   hide-delimiters), e o ícone de cada dica ganha um badge circular com o mesmo gradiente navy do header */
.campanha-vm-dica-slide {
  height: 100%;
}
.campanha-vm-dica-icone {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #023449 0%, #0369a1 100%);
}
.campanha-vm-dica-nav.v-btn {
  background: rgba(2, 52, 73, 0.06) !important;
}
.campanha-vm-dica-nav .v-icon {
  color: #023449 !important;
}

.metric-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
}

.metric-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2) !important;
}

/* Ícone de fundo dos cards */
.card-bg-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 0;
}

.position-relative {
  position: relative;
  z-index: 1;
}

/* Animações de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-card {
  animation: fadeInUp 0.6s ease-out;
}

/* Efeito de brilho nos cards gradientes */
.metric-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
  z-index: 1;
}

.metric-card:hover::before {
  left: 100%;
}

/* Melhorias nos chips */
.v-chip {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: translateY(-1px);
}

/* Progress bars customizadas */
.v-progress-linear {
  border-radius: 10px;
}

/* Avatares com sombra */
.v-avatar {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Efeitos nos ícones */
.v-icon {
  transition: all 0.3s ease;
}

.metric-card:hover .v-icon {
  transform: scale(1.05);
}

/* Responsividade */
@media (max-width: 1264px) {
  .v-col.lg-2 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 960px) {
  .v-col.lg-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .display-2 {
    font-size: 2.5rem !important;
  }

  .metric-card {
    height: auto !important;
    min-height: 200px;
  }

  .metric-card .pa-4 {
    padding: 16px !important;
  }
}

@media (max-width: 600px) {
  .display-2 {
    font-size: 2rem !important;
  }
}

/* Card campanha e-book */
.ebook-header-text {
  min-width: 140px;
  flex-basis: 0;
}

.ebook-ladder-track {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ebook-ladder-pill {
  flex: 1 0 84px;
  padding: 4px 2px;
  border-radius: 8px;
}

.ebook-ladder-valor {
  font-size: 11px;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .ebook-campaign-card.pa-4 {
    padding: 12px !important;
  }

  .ebook-card-header-row {
    flex-wrap: wrap;
  }

  .ebook-header-title {
    font-size: 17px !important;
    margin-bottom: 3px;
  }

  .ebook-header-subtitle {
    font-size: 14px !important;
  }

  .ebook-header-chip {
    flex-shrink: 0;
    margin-left: 68px;
    margin-top: 8px;
  }
}

.v-card .grey--text {
  line-height: 1.5;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.text-h5,
.text-h6 {
  letter-spacing: 0.5px;
}
</style>